/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  Email: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: any;
  Slug: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
};

export type Account = Node & {
  __typename?: 'Account';
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Account`. */
  accountsByOnboardedBy: AccountsConnection;
  /** Reads and enables pagination through a set of `Account`. */
  accountsByReferredBy: AccountsConnection;
  admin?: Maybe<Scalars['Boolean']>;
  amexNotificationSent?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  avatarId?: Maybe<Scalars['UUID']>;
  campaign?: Maybe<Scalars['JSON']>;
  /** Reads a single `Consumer` that is related to this `Account`. */
  consumer?: Maybe<Consumer>;
  /** Reads and enables pagination through a set of `Contact`. */
  contacts: ContactsConnection;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `DocusignEnvelopeRecipient`. */
  docusignEnvelopeRecipients: DocusignEnvelopeRecipientsConnection;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Invitation`. */
  invitations: InvitationsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByReferred: InvitationsConnection;
  lastName: Scalars['String'];
  /** Reads and enables pagination through a set of `Log`. */
  logs: LogsConnection;
  /** Reads and enables pagination through a set of `Media`. */
  media: MediaConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesFrom: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesTo: MessagesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  onboardedBy?: Maybe<Scalars['UUID']>;
  passwordEmpty?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Payment`. */
  payments: PaymentsConnection;
  pointsAvailable?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `PointsLedger`. */
  pointsLedger: PointsLedgersConnection;
  /** Reads a single `Provider` that is related to this `Account`. */
  provider?: Maybe<Provider>;
  referredBy?: Maybe<Scalars['UUID']>;
  suppressMessages?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `UserActivity`. */
  userActivities: UserActivitiesConnection;
};


export type AccountAccountsByOnboardedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


export type AccountAccountsByReferredByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


export type AccountContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};


export type AccountDocusignEnvelopeRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocusignEnvelopeRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocusignEnvelopeRecipientsOrderBy>>;
};


export type AccountInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


export type AccountInvitationsByReferredArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


export type AccountLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};


export type AccountMediaArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};


export type AccountMessagesFromArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type AccountMessagesToArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type AccountPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PaymentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};


export type AccountPointsLedgerArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PointsLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};


export type AccountUserActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserActivityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `avatarId` field. */
  avatarId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `onboardedBy` field. */
  onboardedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referredBy` field. */
  referredBy?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `Account`. Fields that are set will be updated. */
export type AccountPatch = {
  avatarId?: InputMaybe<Scalars['UUID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export enum AccountsOrderBy {
  AvatarIdAsc = 'AVATAR_ID_ASC',
  AvatarIdDesc = 'AVATAR_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OnboardedByAsc = 'ONBOARDED_BY_ASC',
  OnboardedByDesc = 'ONBOARDED_BY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferredByAsc = 'REFERRED_BY_ASC',
  ReferredByDesc = 'REFERRED_BY_DESC'
}

/** All input for the `addInquiryAddress` mutation. */
export type AddInquiryAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
};

/** The output of our `addInquiryAddress` mutation. */
export type AddInquiryAddressPayload = {
  __typename?: 'AddInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addInquiryAddress` mutation. */
export type AddInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `adminUpdateAccount` mutation. */
export type AdminUpdateAccountInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Scalars['JSON'];
};

/** The output of our `adminUpdateAccount` mutation. */
export type AdminUpdateAccountPayload = {
  __typename?: 'AdminUpdateAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `adminUpdateAccount` mutation. */
export type AdminUpdateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

export type Agent = {
  __typename?: 'Agent';
  city?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** A connection to a list of `Agent` values. */
export type AgentsConnection = {
  __typename?: 'AgentsConnection';
  /** A list of edges which contains the `Agent` and cursor to aid in pagination. */
  edges: Array<AgentsEdge>;
  /** A list of `Agent` objects. */
  nodes: Array<Agent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Agent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Agent` edge in the connection. */
export type AgentsEdge = {
  __typename?: 'AgentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Agent` at the end of the edge. */
  node: Agent;
};

export type Consumer = Node & {
  __typename?: 'Consumer';
  /** Reads a single `Account` that is related to this `Consumer`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  appointment?: Maybe<Scalars['String']>;
  consultation?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `DealAgent`. */
  dealAgents: DealAgentsConnection;
  deletedAt?: Maybe<Scalars['Datetime']>;
  engagebay?: Maybe<Scalars['JSON']>;
  hasPotentialProviders?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Inquiry`. */
  inquiries: InquiriesConnection;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Provider`. */
  potentialProviders: ProvidersConnection;
  providersInArea?: Maybe<Scalars['String']>;
  vendors?: Maybe<Scalars['JSON']>;
};


export type ConsumerDealAgentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerInquiriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};


export type ConsumerLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsumerPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Consumer`. Fields that are set will be updated. */
export type ConsumerPatch = {
  consultation?: InputMaybe<Scalars['JSON']>;
  engagebay?: InputMaybe<Scalars['JSON']>;
  providersInArea?: InputMaybe<Scalars['String']>;
  vendors?: InputMaybe<Scalars['JSON']>;
};

/** A connection to a list of `Consumer` values. */
export type ConsumersConnection = {
  __typename?: 'ConsumersConnection';
  /** A list of edges which contains the `Consumer` and cursor to aid in pagination. */
  edges: Array<ConsumersEdge>;
  /** A list of `Consumer` objects. */
  nodes: Array<Consumer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Consumer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Consumer` edge in the connection. */
export type ConsumersEdge = {
  __typename?: 'ConsumersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Consumer` at the end of the edge. */
  node: Consumer;
};

/** Methods to use when ordering `Consumer`. */
export enum ConsumersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EngagebayAsc = 'ENGAGEBAY_ASC',
  EngagebayDesc = 'ENGAGEBAY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Contact = Node & {
  __typename?: 'Contact';
  /** Reads a single `Account` that is related to this `Contact`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type: Scalars['String'];
  undeliverableAt?: Maybe<Scalars['Datetime']>;
  unsubscribedAt?: Maybe<Scalars['Datetime']>;
  value: Scalars['JSON'];
  verificationAttempts?: Maybe<Scalars['Int']>;
  verificationCodeSent?: Maybe<Scalars['Datetime']>;
  verifiedAt?: Maybe<Scalars['Datetime']>;
};

/** A condition to be used against `Contact` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ContactCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** An input for mutations affecting `Contact` */
export type ContactInput = {
  type: Scalars['String'];
  value: Scalars['JSON'];
};

/** All input for the `contactUs` mutation. */
export type ContactUsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** The output of our `contactUs` mutation. */
export type ContactUsPayload = {
  __typename?: 'ContactUsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Contact` values. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges which contains the `Contact` and cursor to aid in pagination. */
  edges: Array<ContactsEdge>;
  /** A list of `Contact` objects. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Contact` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Contact` edge in the connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Contact` at the end of the edge. */
  node: Contact;
};

/** Methods to use when ordering `Contact`. */
export enum ContactsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** All input for the create `Contact` mutation. */
export type CreateContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Contact` to be created by this mutation. */
  contact: ContactInput;
};

/** The output of our create `Contact` mutation. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** Reads a single `Account` that is related to this `Contact`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` that was created by this mutation. */
  contact?: Maybe<Contact>;
  /** An edge for our `Contact`. May be used by Relay 1. */
  contactEdge?: Maybe<ContactsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Contact` mutation. */
export type CreateContactPayloadContactEdgeArgs = {
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};

/** All input for the create `ExternalLead` mutation. */
export type CreateExternalLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalLead` to be created by this mutation. */
  externalLead: ExternalLeadInput;
};

/** The output of our create `ExternalLead` mutation. */
export type CreateExternalLeadPayload = {
  __typename?: 'CreateExternalLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ExternalLead` that was created by this mutation. */
  externalLead?: Maybe<ExternalLead>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `InquiryAddress` mutation. */
export type CreateInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `InquiryAddress` to be created by this mutation. */
  inquiryAddress: InquiryAddressInput;
};

/** The output of our create `InquiryAddress` mutation. */
export type CreateInquiryAddressPayload = {
  __typename?: 'CreateInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was created by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InquiryAddress` mutation. */
export type CreateInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the create `Inquiry` mutation. */
export type CreateInquiryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Inquiry` to be created by this mutation. */
  inquiry: InquiryInput;
};

/** The output of our create `Inquiry` mutation. */
export type CreateInquiryPayload = {
  __typename?: 'CreateInquiryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  /** The `Inquiry` that was created by this mutation. */
  inquiry?: Maybe<Inquiry>;
  /** An edge for our `Inquiry`. May be used by Relay 1. */
  inquiryEdge?: Maybe<InquiriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Inquiry` mutation. */
export type CreateInquiryPayloadInquiryEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};

/** All input for the create `Invitation` mutation. */
export type CreateInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Invitation` to be created by this mutation. */
  invitation: InvitationInput;
};

/** The output of our create `Invitation` mutation. */
export type CreateInvitationPayload = {
  __typename?: 'CreateInvitationPayload';
  /** Reads a single `Account` that is related to this `Invitation`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Invitation`. */
  accountByReferred?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Invitation` that was created by this mutation. */
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Invitation` mutation. */
export type CreateInvitationPayloadInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};

/** All input for the create `Lead` mutation. */
export type CreateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Lead` to be created by this mutation. */
  lead: LeadInput;
};

/** The output of our create `Lead` mutation. */
export type CreateLeadPayload = {
  __typename?: 'CreateLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  /** The `Lead` that was created by this mutation. */
  lead?: Maybe<Lead>;
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>;
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Lead` mutation. */
export type CreateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};

/** All input for the create `License` mutation. */
export type CreateLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `License` to be created by this mutation. */
  license: LicenseInput;
};

/** The output of our create `License` mutation. */
export type CreateLicensePayload = {
  __typename?: 'CreateLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `License` that was created by this mutation. */
  license?: Maybe<License>;
  /** An edge for our `License`. May be used by Relay 1. */
  licenseEdge?: Maybe<LicensesEdge>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `License` mutation. */
export type CreateLicensePayloadLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};

/** All input for the create `Log` mutation. */
export type CreateLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Log` to be created by this mutation. */
  log: LogInput;
};

/** The output of our create `Log` mutation. */
export type CreateLogPayload = {
  __typename?: 'CreateLogPayload';
  /** Reads a single `Account` that is related to this `Log`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Log` that was created by this mutation. */
  log?: Maybe<Log>;
  /** An edge for our `Log`. May be used by Relay 1. */
  logEdge?: Maybe<LogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Log` mutation. */
export type CreateLogPayloadLogEdgeArgs = {
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};

/** All input for the create `Payment` mutation. */
export type CreatePaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Payment` to be created by this mutation. */
  payment: PaymentInput;
};

/** The output of our create `Payment` mutation. */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** Reads a single `Account` that is related to this `Payment`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Payment` that was created by this mutation. */
  payment?: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge?: Maybe<PaymentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Payment` mutation. */
export type CreatePaymentPayloadPaymentEdgeArgs = {
  orderBy?: InputMaybe<Array<PaymentsOrderBy>>;
};

/** All input for the create `PointsLedger` mutation. */
export type CreatePointsLedgerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PointsLedger` to be created by this mutation. */
  pointsLedger: PointsLedgerInput;
};

/** The output of our create `PointsLedger` mutation. */
export type CreatePointsLedgerPayload = {
  __typename?: 'CreatePointsLedgerPayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PointsLedger` that was created by this mutation. */
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PointsLedger` mutation. */
export type CreatePointsLedgerPayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/** All input for the create `ProviderTransaction` mutation. */
export type CreateProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProviderTransaction` to be created by this mutation. */
  providerTransaction: ProviderTransactionInput;
};

/** The output of our create `ProviderTransaction` mutation. */
export type CreateProviderTransactionPayload = {
  __typename?: 'CreateProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was created by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProviderTransaction` mutation. */
export type CreateProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** All input for the create `Redirect` mutation. */
export type CreateRedirectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Redirect` to be created by this mutation. */
  redirect: RedirectInput;
};

/** The output of our create `Redirect` mutation. */
export type CreateRedirectPayload = {
  __typename?: 'CreateRedirectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Redirect` that was created by this mutation. */
  redirect?: Maybe<Redirect>;
  /** An edge for our `Redirect`. May be used by Relay 1. */
  redirectEdge?: Maybe<RedirectsEdge>;
};


/** The output of our create `Redirect` mutation. */
export type CreateRedirectPayloadRedirectEdgeArgs = {
  orderBy?: InputMaybe<Array<RedirectsOrderBy>>;
};

/** All input for the create `UserActivity` mutation. */
export type CreateUserActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserActivity` to be created by this mutation. */
  userActivity: UserActivityInput;
};

/** The output of our create `UserActivity` mutation. */
export type CreateUserActivityPayload = {
  __typename?: 'CreateUserActivityPayload';
  /** Reads a single `Account` that is related to this `UserActivity`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserActivity` that was created by this mutation. */
  userActivity?: Maybe<UserActivity>;
  /** An edge for our `UserActivity`. May be used by Relay 1. */
  userActivityEdge?: Maybe<UserActivitiesEdge>;
};


/** The output of our create `UserActivity` mutation. */
export type CreateUserActivityPayloadUserActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};

export type DealAgent = {
  __typename?: 'DealAgent';
  dealUniqueId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `DealAgent`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
  selected?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of `DealAgent` values. */
export type DealAgentsConnection = {
  __typename?: 'DealAgentsConnection';
  /** A list of edges which contains the `DealAgent` and cursor to aid in pagination. */
  edges: Array<DealAgentsEdge>;
  /** A list of `DealAgent` objects. */
  nodes: Array<DealAgent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DealAgent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DealAgent` edge in the connection. */
export type DealAgentsEdge = {
  __typename?: 'DealAgentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DealAgent` at the end of the edge. */
  node: DealAgent;
};

/** All input for the `deleteContact` mutation. */
export type DeleteContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
};

/** The output of our `deleteContact` mutation. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Contact>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteInquiryAddressById` mutation. */
export type DeleteInquiryAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteInquiryAddress` mutation. */
export type DeleteInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InquiryAddress` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `InquiryAddress` mutation. */
export type DeleteInquiryAddressPayload = {
  __typename?: 'DeleteInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInquiryAddressId?: Maybe<Scalars['ID']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was deleted by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `InquiryAddress` mutation. */
export type DeleteInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `deleteMedia` mutation. */
export type DeleteMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our `deleteMedia` mutation. */
export type DeleteMediaPayload = {
  __typename?: 'DeleteMediaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteProviderTransactionById` mutation. */
export type DeleteProviderTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate` mutation. */
export type DeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput = {
  address1: Scalars['String'];
  city: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  closeDate: Scalars['Date'];
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};

/** All input for the `deleteProviderTransaction` mutation. */
export type DeleteProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProviderTransaction` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `ProviderTransaction` mutation. */
export type DeleteProviderTransactionPayload = {
  __typename?: 'DeleteProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedProviderTransactionId?: Maybe<Scalars['ID']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was deleted by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProviderTransaction` mutation. */
export type DeleteProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

export type DocusignEnvelope = Node & {
  __typename?: 'DocusignEnvelope';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `DocusignEnvelopeRecipient`. */
  docusignEnvelopeRecipients: DocusignEnvelopeRecipientsConnection;
  envelopeId?: Maybe<Scalars['String']>;
  events?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipients?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  template: Scalars['String'];
};


export type DocusignEnvelopeDocusignEnvelopeRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocusignEnvelopeRecipientCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocusignEnvelopeRecipientsOrderBy>>;
};

export type DocusignEnvelopeRecipient = Node & {
  __typename?: 'DocusignEnvelopeRecipient';
  /** Reads a single `Account` that is related to this `DocusignEnvelopeRecipient`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Reads a single `DocusignEnvelope` that is related to this `DocusignEnvelopeRecipient`. */
  docusignEnvelope?: Maybe<DocusignEnvelope>;
  docusignEnvelopeId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  recipientId?: Maybe<Scalars['UUID']>;
  role: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DocusignEnvelopeRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocusignEnvelopeRecipientCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `docusignEnvelopeId` field. */
  docusignEnvelopeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DocusignEnvelopeRecipient` values. */
export type DocusignEnvelopeRecipientsConnection = {
  __typename?: 'DocusignEnvelopeRecipientsConnection';
  /** A list of edges which contains the `DocusignEnvelopeRecipient` and cursor to aid in pagination. */
  edges: Array<DocusignEnvelopeRecipientsEdge>;
  /** A list of `DocusignEnvelopeRecipient` objects. */
  nodes: Array<DocusignEnvelopeRecipient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocusignEnvelopeRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocusignEnvelopeRecipient` edge in the connection. */
export type DocusignEnvelopeRecipientsEdge = {
  __typename?: 'DocusignEnvelopeRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocusignEnvelopeRecipient` at the end of the edge. */
  node: DocusignEnvelopeRecipient;
};

/** Methods to use when ordering `DocusignEnvelopeRecipient`. */
export enum DocusignEnvelopeRecipientsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DocusignEnvelopeIdAsc = 'DOCUSIGN_ENVELOPE_ID_ASC',
  DocusignEnvelopeIdDesc = 'DOCUSIGN_ENVELOPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecipientIdAsc = 'RECIPIENT_ID_ASC',
  RecipientIdDesc = 'RECIPIENT_ID_DESC'
}

export type ExternalLead = Node & {
  __typename?: 'ExternalLead';
  createdAt: Scalars['Datetime'];
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  raw: Scalars['JSON'];
  source: Scalars['String'];
};

/** An input for mutations affecting `ExternalLead` */
export type ExternalLeadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  data: Scalars['JSON'];
  id?: InputMaybe<Scalars['UUID']>;
  raw: Scalars['JSON'];
  source: Scalars['String'];
};

/** All input for the `hire` mutation. */
export type HireInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `hire` mutation. */
export type HirePayload = {
  __typename?: 'HirePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Inquiry` values. */
export type InquiriesConnection = {
  __typename?: 'InquiriesConnection';
  /** A list of edges which contains the `Inquiry` and cursor to aid in pagination. */
  edges: Array<InquiriesEdge>;
  /** A list of `Inquiry` objects. */
  nodes: Array<Inquiry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Inquiry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Inquiry` edge in the connection. */
export type InquiriesEdge = {
  __typename?: 'InquiriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Inquiry` at the end of the edge. */
  node: Inquiry;
};

/** Methods to use when ordering `Inquiry`. */
export enum InquiriesOrderBy {
  ConsumerIdAsc = 'CONSUMER_ID_ASC',
  ConsumerIdDesc = 'CONSUMER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Inquiry = Node & {
  __typename?: 'Inquiry';
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  detailsConfirmed?: Maybe<Scalars['Datetime']>;
  ebDeal?: Maybe<Scalars['JSON']>;
  ebDealUniqueId?: Maybe<Scalars['String']>;
  flags?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InquiryAddress`. */
  inquiryAddresses: InquiryAddressesConnection;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  matches?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  potentialProviders: PotentialProvidersConnection;
  providers?: Maybe<Scalars['JSON']>;
};


export type InquiryInquiryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};


export type InquiryLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};


export type InquiryPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InquiryAddress = Node & {
  __typename?: 'InquiryAddress';
  address: Scalars['String'];
  ebDealUniqueId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  inquiryId: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  location: Scalars['String'];
  longitude: Scalars['BigFloat'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  price?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `InquiryAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InquiryAddressCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inquiryId` field. */
  inquiryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `InquiryAddress` */
export type InquiryAddressInput = {
  address: Scalars['String'];
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  inquiryId: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  location: Scalars['String'];
  longitude: Scalars['BigFloat'];
  price?: InputMaybe<Scalars['BigFloat']>;
};

/** Represents an update to a `InquiryAddress`. Fields that are set will be updated. */
export type InquiryAddressPatch = {
  address?: InputMaybe<Scalars['String']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  location?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
};

/** A connection to a list of `InquiryAddress` values. */
export type InquiryAddressesConnection = {
  __typename?: 'InquiryAddressesConnection';
  /** A list of edges which contains the `InquiryAddress` and cursor to aid in pagination. */
  edges: Array<InquiryAddressesEdge>;
  /** A list of `InquiryAddress` objects. */
  nodes: Array<InquiryAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InquiryAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InquiryAddress` edge in the connection. */
export type InquiryAddressesEdge = {
  __typename?: 'InquiryAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InquiryAddress` at the end of the edge. */
  node: InquiryAddress;
};

/** Methods to use when ordering `InquiryAddress`. */
export enum InquiryAddressesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InquiryIdAsc = 'INQUIRY_ID_ASC',
  InquiryIdDesc = 'INQUIRY_ID_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Inquiry` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type InquiryCondition = {
  /** Checks for equality with the object’s `consumerId` field. */
  consumerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Inquiry` */
export type InquiryInput = {
  details: Scalars['JSON'];
  detailsConfirmed?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Inquiry`. Fields that are set will be updated. */
export type InquiryPatch = {
  details?: InputMaybe<Scalars['JSON']>;
  detailsConfirmed?: InputMaybe<Scalars['Datetime']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Scalars['JSON']>;
  providers?: InputMaybe<Scalars['JSON']>;
};

export type Invitation = Node & {
  __typename?: 'Invitation';
  /** Reads a single `Account` that is related to this `Invitation`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Invitation`. */
  accountByReferred?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  email: Scalars['Email'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  info?: Maybe<Scalars['JSON']>;
  lastName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  referred?: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `Invitation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InvitationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `referred` field. */
  referred?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Invitation` */
export type InvitationInput = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  info?: InputMaybe<Scalars['JSON']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Invitation` values. */
export type InvitationsConnection = {
  __typename?: 'InvitationsConnection';
  /** A list of edges which contains the `Invitation` and cursor to aid in pagination. */
  edges: Array<InvitationsEdge>;
  /** A list of `Invitation` objects. */
  nodes: Array<Invitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invitation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Invitation` edge in the connection. */
export type InvitationsEdge = {
  __typename?: 'InvitationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Invitation` at the end of the edge. */
  node: Invitation;
};

/** Methods to use when ordering `Invitation`. */
export enum InvitationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferredAsc = 'REFERRED_ASC',
  ReferredDesc = 'REFERRED_DESC'
}

export type Lead = Node & {
  __typename?: 'Lead';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  ebDealUniqueId?: Maybe<Scalars['String']>;
  history: Scalars['JSON'];
  id: Scalars['UUID'];
  info: Scalars['JSON'];
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  inquiryId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  status: LeadStatus;
  transaction: Scalars['JSON'];
};

/** A condition to be used against `Lead` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LeadCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inquiryId` field. */
  inquiryId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Lead` */
export type LeadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['JSON']>;
  inquiryId: Scalars['UUID'];
  providerId: Scalars['UUID'];
  status?: InputMaybe<LeadStatus>;
  transaction?: InputMaybe<Scalars['JSON']>;
};

/** Represents an update to a `Lead`. Fields that are set will be updated. */
export type LeadPatch = {
  ebDealUniqueId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  info?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<LeadStatus>;
  transaction?: InputMaybe<Scalars['JSON']>;
};

export enum LeadStatus {
  Closed = 'CLOSED',
  InEscrow = 'IN_ESCROW',
  Shopping = 'SHOPPING',
  WaitingToConnect = 'WAITING_TO_CONNECT'
}

/** A connection to a list of `Lead` values. */
export type LeadsConnection = {
  __typename?: 'LeadsConnection';
  /** A list of edges which contains the `Lead` and cursor to aid in pagination. */
  edges: Array<LeadsEdge>;
  /** A list of `Lead` objects. */
  nodes: Array<Lead>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Lead` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Lead` edge in the connection. */
export type LeadsEdge = {
  __typename?: 'LeadsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Lead` at the end of the edge. */
  node: Lead;
};

/** Methods to use when ordering `Lead`. */
export enum LeadsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InquiryIdAsc = 'INQUIRY_ID_ASC',
  InquiryIdDesc = 'INQUIRY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export type License = Node & {
  __typename?: 'License';
  areaCenter?: Maybe<Scalars['JSON']>;
  bio?: Maybe<Scalars['String']>;
  brokerEmail?: Maybe<Scalars['String']>;
  brokerLicenseNumber?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  brokerPhone?: Maybe<Scalars['String']>;
  brokerageAddress?: Maybe<Scalars['String']>;
  brokerageName?: Maybe<Scalars['String']>;
  brokerageState?: Maybe<Scalars['String']>;
  brokerageTimeZone?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['JSON']>;
  contacts: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  geoJson?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  licenseExpiration?: Maybe<Scalars['Date']>;
  licenseNumber?: Maybe<Scalars['String']>;
  mls: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  primaryPhone?: Maybe<Scalars['String']>;
  professionalCategory?: Maybe<LicenseCategory>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  secondaryPhone?: Maybe<Scalars['String']>;
  serviceAreaUpdated?: Maybe<Scalars['Datetime']>;
  transactionHistory: Scalars['JSON'];
  urls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum LicenseCategory {
  Attorney = 'ATTORNEY',
  MortgageAgent = 'MORTGAGE_AGENT',
  MortgageBroker = 'MORTGAGE_BROKER',
  OtherRealEstateProfessional = 'OTHER_REAL_ESTATE_PROFESSIONAL',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  RealEstateBroker = 'REAL_ESTATE_BROKER',
  TitleAgent = 'TITLE_AGENT'
}

/** A condition to be used against `License` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LicenseCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `License` */
export type LicenseInput = {
  bio?: InputMaybe<Scalars['String']>;
  brokerEmail?: InputMaybe<Scalars['String']>;
  brokerLicenseNumber?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  brokerPhone?: InputMaybe<Scalars['String']>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  brokerageState?: InputMaybe<Scalars['String']>;
  brokerageTimeZone?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  licenseExpiration?: InputMaybe<Scalars['Date']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<Scalars['JSON']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  professionalCategory?: InputMaybe<LicenseCategory>;
  providerId: Scalars['UUID'];
  secondaryPhone?: InputMaybe<Scalars['String']>;
  serviceAreaUpdated?: InputMaybe<Scalars['Datetime']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Represents an update to a `License`. Fields that are set will be updated. */
export type LicensePatch = {
  bio?: InputMaybe<Scalars['String']>;
  brokerEmail?: InputMaybe<Scalars['String']>;
  brokerLicenseNumber?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  brokerPhone?: InputMaybe<Scalars['String']>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  brokerageState?: InputMaybe<Scalars['String']>;
  brokerageTimeZone?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  licenseExpiration?: InputMaybe<Scalars['Date']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<Scalars['JSON']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  professionalCategory?: InputMaybe<LicenseCategory>;
  providerId?: InputMaybe<Scalars['UUID']>;
  secondaryPhone?: InputMaybe<Scalars['String']>;
  serviceAreaUpdated?: InputMaybe<Scalars['Datetime']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A connection to a list of `License` values. */
export type LicensesConnection = {
  __typename?: 'LicensesConnection';
  /** A list of edges which contains the `License` and cursor to aid in pagination. */
  edges: Array<LicensesEdge>;
  /** A list of `License` objects. */
  nodes: Array<License>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `License` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `License` edge in the connection. */
export type LicensesEdge = {
  __typename?: 'LicensesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `License` at the end of the edge. */
  node: License;
};

/** Methods to use when ordering `License`. */
export enum LicensesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export type Link = Node & {
  __typename?: 'Link';
  data?: Maybe<Scalars['JSON']>;
  expiresAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/** A `Link` edge in the connection. */
export type LinksEdge = {
  __typename?: 'LinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Link` at the end of the edge. */
  node: Link;
};

/** Methods to use when ordering `Link`. */
export enum LinksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ListenPayload = {
  __typename?: 'ListenPayload';
  /** Our root query field type. Allows us to run any query from our subscription payload. */
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']>;
};

export type Log = Node & {
  __typename?: 'Log';
  /** Reads a single `Account` that is related to this `Log`. */
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  data: Scalars['JSON'];
  level: LogLevel;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type: Scalars['String'];
};

/** A condition to be used against `Log` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LogCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Log` */
export type LogInput = {
  data: Scalars['JSON'];
  level: LogLevel;
  type: Scalars['String'];
};

export enum LogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Verbose = 'VERBOSE',
  Warn = 'WARN'
}

/** All input for the `loginAs` mutation. */
export type LoginAsInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `loginAs` mutation. */
export type LoginAsPayload = {
  __typename?: 'LoginAsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  /** An edge for our `Link`. May be used by Relay 1. */
  linkEdge?: Maybe<LinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `loginAs` mutation. */
export type LoginAsPayloadLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<LinksOrderBy>>;
};

/** All input for the `login` mutation. */
export type LoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

/** The output of our `login` mutation. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `loginUsingSmsToken` mutation. */
export type LoginUsingSmsTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  token: Scalars['String'];
};

/** The output of our `loginUsingSmsToken` mutation. */
export type LoginUsingSmsTokenPayload = {
  __typename?: 'LoginUsingSmsTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Log` values. */
export type LogsConnection = {
  __typename?: 'LogsConnection';
  /** A list of edges which contains the `Log` and cursor to aid in pagination. */
  edges: Array<LogsEdge>;
  /** A list of `Log` objects. */
  nodes: Array<Log>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Log` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Log` edge in the connection. */
export type LogsEdge = {
  __typename?: 'LogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Log` at the end of the edge. */
  node: Log;
};

/** Methods to use when ordering `Log`. */
export enum LogsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type Media = Node & {
  __typename?: 'Media';
  /** Reads a single `Account` that is related to this `Media`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Media`. */
  accountByAvatarId?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  derivedFrom?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  meta?: Maybe<Scalars['JSON']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Media` that is related to this `Media`. */
  parent?: Maybe<Media>;
  /** Reads and enables pagination through a set of `Media`. */
  sizes: MediaConnection;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uploadedAt?: Maybe<Scalars['Datetime']>;
  url?: Maybe<Scalars['String']>;
};


export type MediaSizesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** A condition to be used against `Media` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MediaCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `derivedFrom` field. */
  derivedFrom?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Media` values. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  /** A list of edges which contains the `Media` and cursor to aid in pagination. */
  edges: Array<MediaEdge>;
  /** A list of `Media` objects. */
  nodes: Array<Media>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Media` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Media` edge in the connection. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Media` at the end of the edge. */
  node: Media;
};

/** Methods to use when ordering `Media`. */
export enum MediaOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DerivedFromAsc = 'DERIVED_FROM_ASC',
  DerivedFromDesc = 'DERIVED_FROM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `Media`. Fields that are set will be updated. */
export type MediaPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Message = Node & {
  __typename?: 'Message';
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Account` that is related to this `Message`. */
  from?: Maybe<Account>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  openedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Account` that is related to this `Message`. */
  to?: Maybe<Account>;
  toId: Scalars['UUID'];
};

/** A condition to be used against `Message` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MessageCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `toId` field. */
  toId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Message` values. */
export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  /** A list of edges which contains the `Message` and cursor to aid in pagination. */
  edges: Array<MessagesEdge>;
  /** A list of `Message` objects. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Message` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Message` edge in the connection. */
export type MessagesEdge = {
  __typename?: 'MessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Message` at the end of the edge. */
  node: Message;
};

/** Methods to use when ordering `Message`. */
export enum MessagesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ToIdAsc = 'TO_ID_ASC',
  ToIdDesc = 'TO_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addInquiryAddress?: Maybe<AddInquiryAddressPayload>;
  adminUpdateAccount?: Maybe<AdminUpdateAccountPayload>;
  contactUs?: Maybe<ContactUsPayload>;
  /** Creates a single `Contact`. */
  createContact?: Maybe<CreateContactPayload>;
  /** Creates a single `ExternalLead`. */
  createExternalLead?: Maybe<CreateExternalLeadPayload>;
  /** Creates a single `Inquiry`. */
  createInquiry?: Maybe<CreateInquiryPayload>;
  /** Creates a single `InquiryAddress`. */
  createInquiryAddress?: Maybe<CreateInquiryAddressPayload>;
  /** Creates a single `Invitation`. */
  createInvitation?: Maybe<CreateInvitationPayload>;
  /** Creates a single `Lead`. */
  createLead?: Maybe<CreateLeadPayload>;
  /** Creates a single `License`. */
  createLicense?: Maybe<CreateLicensePayload>;
  /** Creates a single `Log`. */
  createLog?: Maybe<CreateLogPayload>;
  /** Creates a single `Payment`. */
  createPayment?: Maybe<CreatePaymentPayload>;
  /** Creates a single `PointsLedger`. */
  createPointsLedger?: Maybe<CreatePointsLedgerPayload>;
  /** Creates a single `ProviderTransaction`. */
  createProviderTransaction?: Maybe<CreateProviderTransactionPayload>;
  /** Creates a single `Redirect`. */
  createRedirect?: Maybe<CreateRedirectPayload>;
  /** Creates a single `UserActivity`. */
  createUserActivity?: Maybe<CreateUserActivityPayload>;
  /** Delete a single Contact */
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Deletes a single `InquiryAddress` using its globally unique id. */
  deleteInquiryAddress?: Maybe<DeleteInquiryAddressPayload>;
  /** Deletes a single `InquiryAddress` using a unique key. */
  deleteInquiryAddressById?: Maybe<DeleteInquiryAddressPayload>;
  /** Delete a single Media */
  deleteMedia?: Maybe<DeleteMediaPayload>;
  /** Deletes a single `ProviderTransaction` using its globally unique id. */
  deleteProviderTransaction?: Maybe<DeleteProviderTransactionPayload>;
  /** Deletes a single `ProviderTransaction` using a unique key. */
  deleteProviderTransactionById?: Maybe<DeleteProviderTransactionPayload>;
  /** Deletes a single `ProviderTransaction` using a unique key. */
  deleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<DeleteProviderTransactionPayload>;
  /** Hire a provider. */
  hire?: Maybe<HirePayload>;
  /** Login to account */
  login?: Maybe<LoginPayload>;
  loginAs?: Maybe<LoginAsPayload>;
  loginUsingSmsToken?: Maybe<LoginUsingSmsTokenPayload>;
  pointsLedgerAdjust?: Maybe<PointsLedgerAdjustPayload>;
  pointsLedgerRedeem?: Maybe<PointsLedgerRedeemPayload>;
  /** Create a new consumer. */
  registerConsumer?: Maybe<RegisterConsumerPayload>;
  /** Create a new real estate agent. */
  registerRealEstateAgent?: Maybe<RegisterRealEstateAgentPayload>;
  removeAccount?: Maybe<RemoveAccountPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  restoreAccount?: Maybe<RestoreAccountPayload>;
  /** Send phone number verification code via SMS. */
  sendPhoneVerify?: Maybe<SendPhoneVerifyPayload>;
  sendSmsLoginToken?: Maybe<SendSmsLoginTokenPayload>;
  /** Send verification code to contact. */
  sendVerificationCode?: Maybe<SendVerificationCodePayload>;
  /** Set password */
  setPassword?: Maybe<SetPasswordPayload>;
  /** Login to account using token */
  tokenLogin?: Maybe<TokenLoginPayload>;
  /** Updates a single `Account` using its globally unique id and a patch. */
  updateAccount?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Account` using a unique key and a patch. */
  updateAccountByAvatarId?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Account` using a unique key and a patch. */
  updateAccountById?: Maybe<UpdateAccountPayload>;
  /** Updates a single `Consumer` using its globally unique id and a patch. */
  updateConsumer?: Maybe<UpdateConsumerPayload>;
  /** Updates a single `Consumer` using a unique key and a patch. */
  updateConsumerByAccountId?: Maybe<UpdateConsumerPayload>;
  /** Updates a single `Consumer` using a unique key and a patch. */
  updateConsumerById?: Maybe<UpdateConsumerPayload>;
  updateGeoJson?: Maybe<UpdateGeoJsonPayload>;
  /** Updates a single `Inquiry` using its globally unique id and a patch. */
  updateInquiry?: Maybe<UpdateInquiryPayload>;
  /** Updates a single `InquiryAddress` using its globally unique id and a patch. */
  updateInquiryAddress?: Maybe<UpdateInquiryAddressPayload>;
  /** Updates a single `InquiryAddress` using a unique key and a patch. */
  updateInquiryAddressById?: Maybe<UpdateInquiryAddressPayload>;
  /** Updates a single `Inquiry` using a unique key and a patch. */
  updateInquiryById?: Maybe<UpdateInquiryPayload>;
  /** Updates a single `Lead` using its globally unique id and a patch. */
  updateLead?: Maybe<UpdateLeadPayload>;
  /** Updates a single `Lead` using a unique key and a patch. */
  updateLeadById?: Maybe<UpdateLeadPayload>;
  /** Updates a single `License` using its globally unique id and a patch. */
  updateLicense?: Maybe<UpdateLicensePayload>;
  /** Updates a single `License` using a unique key and a patch. */
  updateLicenseById?: Maybe<UpdateLicensePayload>;
  updateLicenseGeoJson?: Maybe<UpdateLicenseGeoJsonPayload>;
  /** Updates a single `Media` using its globally unique id and a patch. */
  updateMedia?: Maybe<UpdateMediaPayload>;
  /** Updates a single `Media` using a unique key and a patch. */
  updateMediaById?: Maybe<UpdateMediaPayload>;
  /** Updates a single `Provider` using its globally unique id and a patch. */
  updateProvider?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderByAccountId?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderById?: Maybe<UpdateProviderPayload>;
  /** Updates a single `Provider` using a unique key and a patch. */
  updateProviderBySlug?: Maybe<UpdateProviderPayload>;
  /** Updates a single `ProviderTransaction` using its globally unique id and a patch. */
  updateProviderTransaction?: Maybe<UpdateProviderTransactionPayload>;
  /** Updates a single `ProviderTransaction` using a unique key and a patch. */
  updateProviderTransactionById?: Maybe<UpdateProviderTransactionPayload>;
  /** Updates a single `ProviderTransaction` using a unique key and a patch. */
  updateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<UpdateProviderTransactionPayload>;
  updateTransactionLocation?: Maybe<UpdateTransactionLocationPayload>;
  updateTransactionLocationLookupFailed?: Maybe<UpdateTransactionLocationLookupFailedPayload>;
  /** Verify method to contact user. */
  verifyContact?: Maybe<VerifyContactPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddInquiryAddressArgs = {
  input: AddInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateAccountArgs = {
  input: AdminUpdateAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationContactUsArgs = {
  input: ContactUsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalLeadArgs = {
  input: CreateExternalLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInquiryArgs = {
  input: CreateInquiryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInquiryAddressArgs = {
  input: CreateInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLogArgs = {
  input: CreateLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePointsLedgerArgs = {
  input: CreatePointsLedgerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProviderTransactionArgs = {
  input: CreateProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRedirectArgs = {
  input: CreateRedirectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserActivityArgs = {
  input: CreateUserActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInquiryAddressArgs = {
  input: DeleteInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInquiryAddressByIdArgs = {
  input: DeleteInquiryAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaArgs = {
  input: DeleteMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionArgs = {
  input: DeleteProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionByIdArgs = {
  input: DeleteProviderTransactionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  input: DeleteProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHireArgs = {
  input: HireInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginArgs = {
  input: LoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginAsArgs = {
  input: LoginAsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginUsingSmsTokenArgs = {
  input: LoginUsingSmsTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerAdjustArgs = {
  input: PointsLedgerAdjustInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPointsLedgerRedeemArgs = {
  input: PointsLedgerRedeemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterConsumerArgs = {
  input: RegisterConsumerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterRealEstateAgentArgs = {
  input: RegisterRealEstateAgentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRestoreAccountArgs = {
  input: RestoreAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendPhoneVerifyArgs = {
  input: SendPhoneVerifyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendSmsLoginTokenArgs = {
  input: SendSmsLoginTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendVerificationCodeArgs = {
  input: SendVerificationCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTokenLoginArgs = {
  input: TokenLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountByAvatarIdArgs = {
  input: UpdateAccountByAvatarIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountByIdArgs = {
  input: UpdateAccountByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerArgs = {
  input: UpdateConsumerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerByAccountIdArgs = {
  input: UpdateConsumerByAccountIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConsumerByIdArgs = {
  input: UpdateConsumerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeoJsonArgs = {
  input: UpdateGeoJsonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryArgs = {
  input: UpdateInquiryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryAddressArgs = {
  input: UpdateInquiryAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryAddressByIdArgs = {
  input: UpdateInquiryAddressByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInquiryByIdArgs = {
  input: UpdateInquiryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadByIdArgs = {
  input: UpdateLeadByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseByIdArgs = {
  input: UpdateLicenseByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLicenseGeoJsonArgs = {
  input: UpdateLicenseGeoJsonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaArgs = {
  input: UpdateMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaByIdArgs = {
  input: UpdateMediaByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderArgs = {
  input: UpdateProviderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderByAccountIdArgs = {
  input: UpdateProviderByAccountIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderByIdArgs = {
  input: UpdateProviderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderBySlugArgs = {
  input: UpdateProviderBySlugInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionArgs = {
  input: UpdateProviderTransactionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionByIdArgs = {
  input: UpdateProviderTransactionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  input: UpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTransactionLocationArgs = {
  input: UpdateTransactionLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTransactionLocationLookupFailedArgs = {
  input: UpdateTransactionLocationLookupFailedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyContactArgs = {
  input: VerifyContactInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  /** Reads a single `Account` that is related to this `Payment`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  amount?: Maybe<Scalars['BigFloat']>;
  approved?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  lastFour?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  processor?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  type?: Maybe<PaymentType>;
};

/** A condition to be used against `Payment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PaymentCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `approved` field. */
  approved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<PaymentType>;
};

/** An input for mutations affecting `Payment` */
export type PaymentInput = {
  accountId: Scalars['UUID'];
  amount?: InputMaybe<Scalars['BigFloat']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastFour?: InputMaybe<Scalars['String']>;
  processor?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<PaymentType>;
};

export enum PaymentType {
  Membership = 'MEMBERSHIP'
}

/** A connection to a list of `Payment` values. */
export type PaymentsConnection = {
  __typename?: 'PaymentsConnection';
  /** A list of edges which contains the `Payment` and cursor to aid in pagination. */
  edges: Array<PaymentsEdge>;
  /** A list of `Payment` objects. */
  nodes: Array<Payment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Payment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Payment` edge in the connection. */
export type PaymentsEdge = {
  __typename?: 'PaymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Payment` at the end of the edge. */
  node: Payment;
};

/** Methods to use when ordering `Payment`. */
export enum PaymentsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ApprovedAsc = 'APPROVED_ASC',
  ApprovedDesc = 'APPROVED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type PointsLedger = Node & {
  __typename?: 'PointsLedger';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  entryType: PointsLedgerEntryType;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

/** All input for the `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustPayload = {
  __typename?: 'PointsLedgerAdjustPayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `pointsLedgerAdjust` mutation. */
export type PointsLedgerAdjustPayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/**
 * A condition to be used against `PointsLedger` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PointsLedgerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

export enum PointsLedgerEntryType {
  Adjust = 'ADJUST',
  Issue = 'ISSUE',
  Redeem = 'REDEEM'
}

/** An input for mutations affecting `PointsLedger` */
export type PointsLedgerInput = {
  accountId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  entryType: PointsLedgerEntryType;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

/** All input for the `pointsLedgerRedeem` mutation. */
export type PointsLedgerRedeemInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  note: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The output of our `pointsLedgerRedeem` mutation. */
export type PointsLedgerRedeemPayload = {
  __typename?: 'PointsLedgerRedeemPayload';
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `PointsLedger`. */
  accountByCreatedBy?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  pointsLedger?: Maybe<PointsLedger>;
  /** An edge for our `PointsLedger`. May be used by Relay 1. */
  pointsLedgerEdge?: Maybe<PointsLedgersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `pointsLedgerRedeem` mutation. */
export type PointsLedgerRedeemPayloadPointsLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<PointsLedgersOrderBy>>;
};

/** A connection to a list of `PointsLedger` values. */
export type PointsLedgersConnection = {
  __typename?: 'PointsLedgersConnection';
  /** A list of edges which contains the `PointsLedger` and cursor to aid in pagination. */
  edges: Array<PointsLedgersEdge>;
  /** A list of `PointsLedger` objects. */
  nodes: Array<PointsLedger>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointsLedger` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointsLedger` edge in the connection. */
export type PointsLedgersEdge = {
  __typename?: 'PointsLedgersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointsLedger` at the end of the edge. */
  node: PointsLedger;
};

/** Methods to use when ordering `PointsLedger`. */
export enum PointsLedgersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PotentialProvider = {
  __typename?: 'PotentialProvider';
  distance?: Maybe<Scalars['Float']>;
  /** Reads a single `Provider` that is related to this `PotentialProvider`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
  transactionCount?: Maybe<Scalars['BigInt']>;
};

/** A connection to a list of `PotentialProvider` values. */
export type PotentialProvidersConnection = {
  __typename?: 'PotentialProvidersConnection';
  /** A list of edges which contains the `PotentialProvider` and cursor to aid in pagination. */
  edges: Array<PotentialProvidersEdge>;
  /** A list of `PotentialProvider` objects. */
  nodes: Array<PotentialProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PotentialProvider` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PotentialProvider` edge in the connection. */
export type PotentialProvidersEdge = {
  __typename?: 'PotentialProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PotentialProvider` at the end of the edge. */
  node: PotentialProvider;
};

export type Provider = Node & {
  __typename?: 'Provider';
  /** Reads a single `Account` that is related to this `Provider`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  approvalRequested?: Maybe<Scalars['Datetime']>;
  approved: Scalars['Boolean'];
  areaCenter?: Maybe<Scalars['JSON']>;
  areaUpdated?: Maybe<Scalars['Datetime']>;
  bizDev?: Maybe<Scalars['Boolean']>;
  brokerageName?: Maybe<Scalars['String']>;
  cities?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  docusignExpiration?: Maybe<Scalars['Date']>;
  docusignSigned?: Maybe<Scalars['Date']>;
  docusignStatus?: Maybe<Scalars['String']>;
  email: Scalars['Email'];
  engagebay?: Maybe<Scalars['JSON']>;
  engagebayId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geoJson?: Maybe<Scalars['JSON']>;
  heshe?: Maybe<Scalars['String']>;
  himher?: Maybe<Scalars['String']>;
  hisher?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads a single `Media` that is related to this `Provider`. */
  image?: Maybe<Media>;
  imageId?: Maybe<Scalars['UUID']>;
  info: Scalars['JSON'];
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection;
  /** Reads and enables pagination through a set of `License`. */
  licenses: LicensesConnection;
  location?: Maybe<Scalars['JSON']>;
  maxPrice?: Maybe<Scalars['Int']>;
  minPrice?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  profileComplete?: Maybe<Scalars['Int']>;
  pronouns?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  setupComplete?: Maybe<Scalars['Datetime']>;
  signed?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['Slug']>;
  specialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['JSON']>;
  syntheticStatus?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  transactionHistory: Scalars['JSON'];
  transactionLocations?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `ProviderTransaction`. */
  transactions: ProviderTransactionsConnection;
  type: ProviderType;
};


export type ProviderLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LeadCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};


export type ProviderLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LicenseCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};


export type ProviderTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProviderTransactionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/**
 * A condition to be used against `Provider` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProviderCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagebay` field. */
  engagebay?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `imageId` field. */
  imageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['Slug']>;
};

/** Represents an update to a `Provider`. Fields that are set will be updated. */
export type ProviderPatch = {
  accountId?: InputMaybe<Scalars['UUID']>;
  approvalRequested?: InputMaybe<Scalars['Datetime']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  areaCenter?: InputMaybe<Scalars['JSON']>;
  areaUpdated?: InputMaybe<Scalars['Datetime']>;
  bizDev?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Email']>;
  engagebay?: InputMaybe<Scalars['JSON']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageId?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['JSON']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  setupComplete?: InputMaybe<Scalars['Datetime']>;
  slug?: InputMaybe<Scalars['Slug']>;
  specialties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['JSON']>;
  tier?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  transactionHistory?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<ProviderType>;
};

export type ProviderTransaction = Node & {
  __typename?: 'ProviderTransaction';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  closePrice: Scalars['Int'];
  id: Scalars['UUID'];
  location?: Maybe<Scalars['JSON']>;
  lookupFailed?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `ProviderTransaction` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProviderTransactionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['UUID']>;
};

export type ProviderTransactionCount = {
  __typename?: 'ProviderTransactionCount';
  count?: Maybe<Scalars['BigInt']>;
  /** Reads a single `Provider` that is related to this `ProviderTransactionCount`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `ProviderTransactionCount` values. */
export type ProviderTransactionCountsConnection = {
  __typename?: 'ProviderTransactionCountsConnection';
  /** A list of edges which contains the `ProviderTransactionCount` and cursor to aid in pagination. */
  edges: Array<ProviderTransactionCountsEdge>;
  /** A list of `ProviderTransactionCount` objects. */
  nodes: Array<ProviderTransactionCount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderTransactionCount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProviderTransactionCount` edge in the connection. */
export type ProviderTransactionCountsEdge = {
  __typename?: 'ProviderTransactionCountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProviderTransactionCount` at the end of the edge. */
  node: ProviderTransactionCount;
};

/** An input for mutations affecting `ProviderTransaction` */
export type ProviderTransactionInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  closePrice: Scalars['Int'];
  id?: InputMaybe<Scalars['UUID']>;
  lookupFailed?: InputMaybe<Scalars['Datetime']>;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `ProviderTransaction`. Fields that are set will be updated. */
export type ProviderTransactionPatch = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  closePrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lookupFailed?: InputMaybe<Scalars['Datetime']>;
  providerId?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `ProviderTransaction` values. */
export type ProviderTransactionsConnection = {
  __typename?: 'ProviderTransactionsConnection';
  /** A list of edges which contains the `ProviderTransaction` and cursor to aid in pagination. */
  edges: Array<ProviderTransactionsEdge>;
  /** A list of `ProviderTransaction` objects. */
  nodes: Array<ProviderTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderTransaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProviderTransaction` edge in the connection. */
export type ProviderTransactionsEdge = {
  __typename?: 'ProviderTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProviderTransaction` at the end of the edge. */
  node: ProviderTransaction;
};

/** Methods to use when ordering `ProviderTransaction`. */
export enum ProviderTransactionsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC'
}

export enum ProviderType {
  RealEstateAgent = 'REAL_ESTATE_AGENT'
}

/** A connection to a list of `Provider` values. */
export type ProvidersConnection = {
  __typename?: 'ProvidersConnection';
  /** A list of edges which contains the `Provider` and cursor to aid in pagination. */
  edges: Array<ProvidersEdge>;
  /** A list of `Provider` objects. */
  nodes: Array<Provider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Provider` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Provider` edge in the connection. */
export type ProvidersEdge = {
  __typename?: 'ProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Provider` at the end of the edge. */
  node: Provider;
};

/** Methods to use when ordering `Provider`. */
export enum ProvidersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  EngagebayAsc = 'ENGAGEBAY_ASC',
  EngagebayDesc = 'ENGAGEBAY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImageIdAsc = 'IMAGE_ID_ASC',
  ImageIdDesc = 'IMAGE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `Account` using its globally unique `ID`. */
  account?: Maybe<Account>;
  accountByAvatarId?: Maybe<Account>;
  accountById?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Agent`. */
  agentsByCityState?: Maybe<AgentsConnection>;
  /** Reads and enables pagination through a set of `Consumer`. */
  allConsumers?: Maybe<ConsumersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  allProviders?: Maybe<ProvidersConnection>;
  areaCoverage?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  areaPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** City autocomplete search, sorting by distance from zip. */
  autocompleteLocation?: Maybe<Scalars['JSON']>;
  citiesDistance?: Maybe<Scalars['Float']>;
  cityDistance?: Maybe<Scalars['Float']>;
  cityGeoJson?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  cityStatePotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `Consumer` using its globally unique `ID`. */
  consumer?: Maybe<Consumer>;
  consumerByAccountId?: Maybe<Consumer>;
  consumerById?: Maybe<Consumer>;
  /** Reads and enables pagination through a set of `Consumer`. */
  consumersByLocation?: Maybe<ConsumersConnection>;
  /** Reads a single `Contact` using its globally unique `ID`. */
  contact?: Maybe<Contact>;
  contactById?: Maybe<Contact>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  dealPotentialProviders?: Maybe<PotentialProvidersConnection>;
  /** Reads a single `DocusignEnvelope` using its globally unique `ID`. */
  docusignEnvelope?: Maybe<DocusignEnvelope>;
  docusignEnvelopeByEnvelopeId?: Maybe<DocusignEnvelope>;
  docusignEnvelopeById?: Maybe<DocusignEnvelope>;
  /** Reads a single `DocusignEnvelopeRecipient` using its globally unique `ID`. */
  docusignEnvelopeRecipient?: Maybe<DocusignEnvelopeRecipient>;
  docusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountId?: Maybe<DocusignEnvelopeRecipient>;
  /** Reads and enables pagination through a set of `Provider`. */
  findProviders?: Maybe<ProvidersConnection>;
  getNextProviderTransaction?: Maybe<ProviderTransaction>;
  getProviderByEmail?: Maybe<Provider>;
  getProviderByName?: Maybe<Provider>;
  /** Reads a single `Inquiry` using its globally unique `ID`. */
  inquiry?: Maybe<Inquiry>;
  /** Reads a single `InquiryAddress` using its globally unique `ID`. */
  inquiryAddress?: Maybe<InquiryAddress>;
  inquiryAddressById?: Maybe<InquiryAddress>;
  /** Reads and enables pagination through a set of `InquiryAddress`. */
  inquiryAddresses?: Maybe<InquiryAddressesConnection>;
  inquiryById?: Maybe<Inquiry>;
  /** Reads a single `Invitation` using its globally unique `ID`. */
  invitation?: Maybe<Invitation>;
  invitationById?: Maybe<Invitation>;
  /** Reads a single `Lead` using its globally unique `ID`. */
  lead?: Maybe<Lead>;
  leadById?: Maybe<Lead>;
  /** Reads a single `License` using its globally unique `ID`. */
  license?: Maybe<License>;
  licenseById?: Maybe<License>;
  /** Reads a single `Link` using its globally unique `ID`. */
  link?: Maybe<Link>;
  linkById?: Maybe<Link>;
  /** Reads a single `Log` using its globally unique `ID`. */
  log?: Maybe<Log>;
  /** Reads a single `Media` using its globally unique `ID`. */
  media?: Maybe<Media>;
  mediaById?: Maybe<Media>;
  /** Reads a single `Message` using its globally unique `ID`. */
  message?: Maybe<Message>;
  messageById?: Maybe<Message>;
  /** Find the closest location to the given latitude and longitude. */
  nearestZip?: Maybe<Scalars['JSON']>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Reads a single `Payment` using its globally unique `ID`. */
  payment?: Maybe<Payment>;
  paymentById?: Maybe<Payment>;
  /** Reads a single `PointsLedger` using its globally unique `ID`. */
  pointsLedger?: Maybe<PointsLedger>;
  pointsLedgerById?: Maybe<PointsLedger>;
  /** Reads a single `Provider` using its globally unique `ID`. */
  provider?: Maybe<Provider>;
  providerByAccountId?: Maybe<Provider>;
  providerById?: Maybe<Provider>;
  providerBySlug?: Maybe<Provider>;
  /** Reads a single `ProviderTransaction` using its globally unique `ID`. */
  providerTransaction?: Maybe<ProviderTransaction>;
  providerTransactionById?: Maybe<ProviderTransaction>;
  providerTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate?: Maybe<ProviderTransaction>;
  /** Reads and enables pagination through a set of `Provider`. */
  providers?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersByCityState?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersByLocation?: Maybe<ProvidersConnection>;
  /** Reads and enables pagination through a set of `ProviderTransactionCount`. */
  providersByTransactionLocation?: Maybe<ProviderTransactionCountsConnection>;
  /** Reads and enables pagination through a set of `Provider`. */
  providersNearest?: Maybe<ProvidersConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `Redirect` using its globally unique `ID`. */
  redirect?: Maybe<Redirect>;
  redirectById?: Maybe<Redirect>;
  redirectByPath?: Maybe<Redirect>;
  /** Reads and enables pagination through a set of `Redirect`. */
  redirects?: Maybe<RedirectsConnection>;
  /** Reads and enables pagination through a set of `UserActivity`. */
  userActivities?: Maybe<UserActivitiesConnection>;
  /** Reads a single `UserActivity` using its globally unique `ID`. */
  userActivity?: Maybe<UserActivity>;
  userActivityById?: Maybe<UserActivity>;
  /** Current user's info. */
  viewer?: Maybe<Account>;
  zipGeoJson?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PotentialProvider`. */
  zipPotentialProviders?: Maybe<PotentialProvidersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByAvatarIdArgs = {
  avatarId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAgentsByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllConsumersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaCoverageArgs = {
  locationId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAreaPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  area?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAutocompleteLocationArgs = {
  search: Scalars['String'];
  zipCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCitiesDistanceArgs = {
  city1?: InputMaybe<Scalars['String']>;
  city2?: InputMaybe<Scalars['String']>;
  state1?: InputMaybe<Scalars['String']>;
  state2?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityDistanceArgs = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityGeoJsonArgs = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCityStatePotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDealPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  dealUniqueId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeByEnvelopeIdArgs = {
  envelopeId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeRecipientArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocusignEnvelopeRecipientByDocusignEnvelopeIdAndAccountIdArgs = {
  accountId: Scalars['UUID'];
  docusignEnvelopeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFindProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  inquiryId?: InputMaybe<Scalars['UUID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProviderType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetNextProviderTransactionArgs = {
  t?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProviderByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProviderByNameArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InquiryAddressCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInquiryByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLeadByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLicenseArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLicenseByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLinkByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNearestZipArgs = {
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointsLedgerArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointsLedgerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderByAccountIdArgs = {
  accountId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderBySlugArgs = {
  slug: Scalars['Slug'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateArgs = {
  address1: Scalars['String'];
  city: Scalars['String'];
  closeDate: Scalars['Date'];
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProviderCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByCityStateArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  miles?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersByTransactionLocationArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProvidersNearestArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['BigFloat']>;
  longitude?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectByPathArgs = {
  path: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRedirectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RedirectCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RedirectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserActivityCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivityArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserActivityByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZipGeoJsonArgs = {
  zipCode?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZipPotentialProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxDistance?: InputMaybe<Scalars['BigFloat']>;
  offset?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Redirect = Node & {
  __typename?: 'Redirect';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/**
 * A condition to be used against `Redirect` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RedirectCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `Redirect` */
export type RedirectInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
};

/** A connection to a list of `Redirect` values. */
export type RedirectsConnection = {
  __typename?: 'RedirectsConnection';
  /** A list of edges which contains the `Redirect` and cursor to aid in pagination. */
  edges: Array<RedirectsEdge>;
  /** A list of `Redirect` objects. */
  nodes: Array<Redirect>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Redirect` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Redirect` edge in the connection. */
export type RedirectsEdge = {
  __typename?: 'RedirectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Redirect` at the end of the edge. */
  node: Redirect;
};

/** Methods to use when ordering `Redirect`. */
export enum RedirectsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `registerConsumer` mutation. */
export type RegisterConsumerInput = {
  campaign?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `registerConsumer` mutation. */
export type RegisterConsumerPayload = {
  __typename?: 'RegisterConsumerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerRealEstateAgent` mutation. */
export type RegisterRealEstateAgentInput = {
  campaign?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['UUID']>;
  serviceAreaZipCode?: InputMaybe<Scalars['String']>;
};

/** The output of our `registerRealEstateAgent` mutation. */
export type RegisterRealEstateAgentPayload = {
  __typename?: 'RegisterRealEstateAgentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeAccount` mutation. */
export type RemoveAccountInput = {
  aid: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `removeAccount` mutation. */
export type RemoveAccountPayload = {
  __typename?: 'RemoveAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `removeAccount` mutation. */
export type RemoveAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `resetPassword` mutation. */
export type ResetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** The output of our `resetPassword` mutation. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `restoreAccount` mutation. */
export type RestoreAccountInput = {
  aid: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `restoreAccount` mutation. */
export type RestoreAccountPayload = {
  __typename?: 'RestoreAccountPayload';
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `restoreAccount` mutation. */
export type RestoreAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `sendPhoneVerify` mutation. */
export type SendPhoneVerifyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['UUID'];
};

/** The output of our `sendPhoneVerify` mutation. */
export type SendPhoneVerifyPayload = {
  __typename?: 'SendPhoneVerifyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendSmsLoginToken` mutation. */
export type SendSmsLoginTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** The output of our `sendSmsLoginToken` mutation. */
export type SendSmsLoginTokenPayload = {
  __typename?: 'SendSmsLoginTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendVerificationCode` mutation. */
export type SendVerificationCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['UUID'];
};

/** The output of our `sendVerificationCode` mutation. */
export type SendVerificationCodePayload = {
  __typename?: 'SendVerificationCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setPassword` mutation. */
export type SetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

/** The output of our `setPassword` mutation. */
export type SetPasswordPayload = {
  __typename?: 'SetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  listen: ListenPayload;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionListenArgs = {
  topic: Scalars['String'];
};

/** All input for the `tokenLogin` mutation. */
export type TokenLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['UUID'];
};

/** The output of our `tokenLogin` mutation. */
export type TokenLoginPayload = {
  __typename?: 'TokenLoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAccountByAvatarId` mutation. */
export type UpdateAccountByAvatarIdInput = {
  avatarId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** All input for the `updateAccountById` mutation. */
export type UpdateAccountByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** All input for the `updateAccount` mutation. */
export type UpdateAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Account` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Account` being updated. */
  patch: AccountPatch;
};

/** The output of our update `Account` mutation. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  /** The `Account` that was updated by this mutation. */
  account?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByOnboardedBy?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Account`. */
  accountByReferredBy?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /** Reads a single `Media` that is related to this `Account`. */
  avatar?: Maybe<Media>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Account` mutation. */
export type UpdateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `updateConsumerByAccountId` mutation. */
export type UpdateConsumerByAccountIdInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** All input for the `updateConsumerById` mutation. */
export type UpdateConsumerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** All input for the `updateConsumer` mutation. */
export type UpdateConsumerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Consumer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Consumer` being updated. */
  patch: ConsumerPatch;
};

/** The output of our update `Consumer` mutation. */
export type UpdateConsumerPayload = {
  __typename?: 'UpdateConsumerPayload';
  /** Reads a single `Account` that is related to this `Consumer`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Consumer` that was updated by this mutation. */
  consumer?: Maybe<Consumer>;
  /** An edge for our `Consumer`. May be used by Relay 1. */
  consumerEdge?: Maybe<ConsumersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Consumer` mutation. */
export type UpdateConsumerPayloadConsumerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConsumersOrderBy>>;
};

/** All input for the `updateGeoJson` mutation. */
export type UpdateGeoJsonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geoJson?: InputMaybe<Scalars['JSON']>;
  pid?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `updateGeoJson` mutation. */
export type UpdateGeoJsonPayload = {
  __typename?: 'UpdateGeoJsonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateInquiryAddressById` mutation. */
export type UpdateInquiryAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `InquiryAddress` being updated. */
  patch: InquiryAddressPatch;
};

/** All input for the `updateInquiryAddress` mutation. */
export type UpdateInquiryAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InquiryAddress` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InquiryAddress` being updated. */
  patch: InquiryAddressPatch;
};

/** The output of our update `InquiryAddress` mutation. */
export type UpdateInquiryAddressPayload = {
  __typename?: 'UpdateInquiryAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `InquiryAddress`. */
  inquiry?: Maybe<Inquiry>;
  /** The `InquiryAddress` that was updated by this mutation. */
  inquiryAddress?: Maybe<InquiryAddress>;
  /** An edge for our `InquiryAddress`. May be used by Relay 1. */
  inquiryAddressEdge?: Maybe<InquiryAddressesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InquiryAddress` mutation. */
export type UpdateInquiryAddressPayloadInquiryAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiryAddressesOrderBy>>;
};

/** All input for the `updateInquiryById` mutation. */
export type UpdateInquiryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Inquiry` being updated. */
  patch: InquiryPatch;
};

/** All input for the `updateInquiry` mutation. */
export type UpdateInquiryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Inquiry` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Inquiry` being updated. */
  patch: InquiryPatch;
};

/** The output of our update `Inquiry` mutation. */
export type UpdateInquiryPayload = {
  __typename?: 'UpdateInquiryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Consumer` that is related to this `Inquiry`. */
  consumer?: Maybe<Consumer>;
  /** The `Inquiry` that was updated by this mutation. */
  inquiry?: Maybe<Inquiry>;
  /** An edge for our `Inquiry`. May be used by Relay 1. */
  inquiryEdge?: Maybe<InquiriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Inquiry` mutation. */
export type UpdateInquiryPayloadInquiryEdgeArgs = {
  orderBy?: InputMaybe<Array<InquiriesOrderBy>>;
};

/** All input for the `updateLeadById` mutation. */
export type UpdateLeadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch;
};

/** All input for the `updateLead` mutation. */
export type UpdateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Lead` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch;
};

/** The output of our update `Lead` mutation. */
export type UpdateLeadPayload = {
  __typename?: 'UpdateLeadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Inquiry` that is related to this `Lead`. */
  inquiry?: Maybe<Inquiry>;
  /** The `Lead` that was updated by this mutation. */
  lead?: Maybe<Lead>;
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>;
  /** Reads a single `Provider` that is related to this `Lead`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Lead` mutation. */
export type UpdateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>;
};

/** All input for the `updateLicenseById` mutation. */
export type UpdateLicenseByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `License` being updated. */
  patch: LicensePatch;
};

/** All input for the `updateLicenseGeoJson` mutation. */
export type UpdateLicenseGeoJsonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  geoJson?: InputMaybe<Scalars['JSON']>;
  lid?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `updateLicenseGeoJson` mutation. */
export type UpdateLicenseGeoJsonPayload = {
  __typename?: 'UpdateLicenseGeoJsonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateLicense` mutation. */
export type UpdateLicenseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `License` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `License` being updated. */
  patch: LicensePatch;
};

/** The output of our update `License` mutation. */
export type UpdateLicensePayload = {
  __typename?: 'UpdateLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `License` that was updated by this mutation. */
  license?: Maybe<License>;
  /** An edge for our `License`. May be used by Relay 1. */
  licenseEdge?: Maybe<LicensesEdge>;
  /** Reads a single `Provider` that is related to this `License`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `License` mutation. */
export type UpdateLicensePayloadLicenseEdgeArgs = {
  orderBy?: InputMaybe<Array<LicensesOrderBy>>;
};

/** All input for the `updateMediaById` mutation. */
export type UpdateMediaByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Media` being updated. */
  patch: MediaPatch;
};

/** All input for the `updateMedia` mutation. */
export type UpdateMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Media` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Media` being updated. */
  patch: MediaPatch;
};

/** The output of our update `Media` mutation. */
export type UpdateMediaPayload = {
  __typename?: 'UpdateMediaPayload';
  /** Reads a single `Account` that is related to this `Media`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Media` that was updated by this mutation. */
  media?: Maybe<Media>;
  /** An edge for our `Media`. May be used by Relay 1. */
  mediaEdge?: Maybe<MediaEdge>;
  /** Reads a single `Media` that is related to this `Media`. */
  parent?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Media` mutation. */
export type UpdateMediaPayloadMediaEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** All input for the `updateProviderByAccountId` mutation. */
export type UpdateProviderByAccountIdInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** All input for the `updateProviderById` mutation. */
export type UpdateProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** All input for the `updateProviderBySlug` mutation. */
export type UpdateProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
  slug: Scalars['Slug'];
};

/** All input for the `updateProvider` mutation. */
export type UpdateProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Provider` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Provider` being updated. */
  patch: ProviderPatch;
};

/** The output of our update `Provider` mutation. */
export type UpdateProviderPayload = {
  __typename?: 'UpdateProviderPayload';
  /** Reads a single `Account` that is related to this `Provider`. */
  account?: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Media` that is related to this `Provider`. */
  image?: Maybe<Media>;
  /** The `Provider` that was updated by this mutation. */
  provider?: Maybe<Provider>;
  /** An edge for our `Provider`. May be used by Relay 1. */
  providerEdge?: Maybe<ProvidersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Provider` mutation. */
export type UpdateProviderPayloadProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};

/** All input for the `updateProviderTransactionById` mutation. */
export type UpdateProviderTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
};

/** All input for the `updateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDate` mutation. */
export type UpdateProviderTransactionByProviderIdAndAddress1AndCityAndStateAndCloseDateInput = {
  address1: Scalars['String'];
  city: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  closeDate: Scalars['Date'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
  providerId: Scalars['UUID'];
  state: Scalars['String'];
};

/** All input for the `updateProviderTransaction` mutation. */
export type UpdateProviderTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProviderTransaction` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProviderTransaction` being updated. */
  patch: ProviderTransactionPatch;
};

/** The output of our update `ProviderTransaction` mutation. */
export type UpdateProviderTransactionPayload = {
  __typename?: 'UpdateProviderTransactionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  /** The `ProviderTransaction` that was updated by this mutation. */
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProviderTransaction` mutation. */
export type UpdateProviderTransactionPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** All input for the `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
};

/** All input for the `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedPayload = {
  __typename?: 'UpdateTransactionLocationLookupFailedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateTransactionLocationLookupFailed` mutation. */
export type UpdateTransactionLocationLookupFailedPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** The output of our `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationPayload = {
  __typename?: 'UpdateTransactionLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Provider` that is related to this `ProviderTransaction`. */
  provider?: Maybe<Provider>;
  providerTransaction?: Maybe<ProviderTransaction>;
  /** An edge for our `ProviderTransaction`. May be used by Relay 1. */
  providerTransactionEdge?: Maybe<ProviderTransactionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateTransactionLocation` mutation. */
export type UpdateTransactionLocationPayloadProviderTransactionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderTransactionsOrderBy>>;
};

/** A connection to a list of `UserActivity` values. */
export type UserActivitiesConnection = {
  __typename?: 'UserActivitiesConnection';
  /** A list of edges which contains the `UserActivity` and cursor to aid in pagination. */
  edges: Array<UserActivitiesEdge>;
  /** A list of `UserActivity` objects. */
  nodes: Array<UserActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserActivity` edge in the connection. */
export type UserActivitiesEdge = {
  __typename?: 'UserActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserActivity` at the end of the edge. */
  node: UserActivity;
};

/** Methods to use when ordering `UserActivity`. */
export enum UserActivitiesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type UserActivity = Node & {
  __typename?: 'UserActivity';
  /** Reads a single `Account` that is related to this `UserActivity`. */
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  instanceId: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  path: Scalars['String'];
};

/**
 * A condition to be used against `UserActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserActivityCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `UserActivity` */
export type UserActivityInput = {
  data?: InputMaybe<Scalars['JSON']>;
  instanceId: Scalars['String'];
  path: Scalars['String'];
};

/** All input for the `verifyContact` mutation. */
export type VerifyContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  contactId: Scalars['UUID'];
};

/** The output of our `verifyContact` mutation. */
export type VerifyContactPayload = {
  __typename?: 'VerifyContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  verifyContactResult?: Maybe<VerifyContactResult>;
};

export type VerifyContactResult = {
  __typename?: 'VerifyContactResult';
  message?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type AccountByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AccountByIdQuery = { __typename?: 'Query', accountById?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, id: any, type: string, value: any }> } } | null };

export type AdminUpdateAccountMutationVariables = Exact<{
  input: AdminUpdateAccountInput;
}>;


export type AdminUpdateAccountMutation = { __typename?: 'Mutation', adminUpdateAccount?: { __typename?: 'AdminUpdateAccountPayload', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, id: any, type: string, value: any }> }, provider?: { __typename?: 'Provider', nodeId: string, name: string, email: any } | null } | null } | null };

export type AgentsByCityStateQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
}>;


export type AgentsByCityStateQuery = { __typename?: 'Query', agentsByCityState?: { __typename?: 'AgentsConnection', nodes: Array<{ __typename?: 'Agent', firstName?: string | null, lastName?: string | null, email?: string | null, companyName?: string | null, companyAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, companyPhone?: string | null, phone?: string | null }> } | null };

export type AutocompleteLocationQueryVariables = Exact<{
  search: Scalars['String'];
  zipCode: Scalars['String'];
}>;


export type AutocompleteLocationQuery = { __typename?: 'Query', autocompleteLocation?: any | null };

export type CityGeoJsonQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type CityGeoJsonQuery = { __typename?: 'Query', cityGeoJson?: any | null };

export type ConsumerDataFragment = { __typename?: 'Consumer', nodeId: string, id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, providersInArea?: string | null, consultation?: any | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, suppressMessages?: boolean | null, campaign?: any | null, pointsAvailable?: number | null, deletedAt?: any | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any, verifiedAt?: any | null, undeliverableAt?: any | null }> }, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', firstName: string, lastName: string, phone?: string | null, email: any, createdAt: any }> }, pointsLedger: { __typename?: 'PointsLedgersConnection', nodes: Array<{ __typename?: 'PointsLedger', nodeId: string, id: any, entryType: PointsLedgerEntryType, quantity: number, note?: string | null, createdAt: any, accountByCreatedBy?: { __typename?: 'Account', firstName: string, lastName: string, nodeId: string, id: any } | null }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', nodeId: string, id: any, details: any, detailsConfirmed?: any | null, providers?: any | null, flags?: any | null, leads: { __typename?: 'LeadsConnection', nodes: Array<{ __typename?: 'Lead', nodeId: string, ebDealUniqueId?: string | null, provider?: { __typename?: 'Provider', nodeId: string, name: string, phone?: string | null, email: any } | null }> } }> } } & { ' $fragmentName'?: 'ConsumerDataFragment' };

export type ConsumerByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ConsumerByIdQuery = { __typename?: 'Query', consumerById?: { __typename?: 'Consumer', nodeId: string, id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, providersInArea?: string | null, consultation?: any | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, suppressMessages?: boolean | null, campaign?: any | null, pointsAvailable?: number | null, deletedAt?: any | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any, verifiedAt?: any | null, undeliverableAt?: any | null }> }, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', firstName: string, lastName: string, phone?: string | null, email: any, createdAt: any }> }, pointsLedger: { __typename?: 'PointsLedgersConnection', nodes: Array<{ __typename?: 'PointsLedger', nodeId: string, id: any, entryType: PointsLedgerEntryType, quantity: number, note?: string | null, createdAt: any, accountByCreatedBy?: { __typename?: 'Account', firstName: string, lastName: string, nodeId: string, id: any } | null }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', nodeId: string, id: any, details: any, detailsConfirmed?: any | null, providers?: any | null, flags?: any | null, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any, ebDealUniqueId?: string | null }> }, leads: { __typename?: 'LeadsConnection', nodes: Array<{ __typename?: 'Lead', nodeId: string, ebDealUniqueId?: string | null, provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, phone?: string | null, email: any, engagebay?: any | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> } }> } } | null };

export type UpdateConsumerMutationVariables = Exact<{
  input: UpdateConsumerInput;
}>;


export type UpdateConsumerMutation = { __typename?: 'Mutation', updateConsumer?: { __typename?: 'UpdateConsumerPayload', consumer?: { __typename?: 'Consumer', nodeId: string, engagebay?: any | null, consultation?: any | null } | null } | null };

export type ConsumersListQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ConsumersListQuery = { __typename?: 'Query', allConsumers?: { __typename?: 'ConsumersConnection', nodes: Array<(
      { __typename?: 'Consumer' }
      & { ' $fragmentRefs'?: { 'ConsumerDataFragment': ConsumerDataFragment } }
    )> } | null };

export type ConsumersByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type ConsumersByLocationQuery = { __typename?: 'Query', consumersByLocation?: { __typename?: 'ConsumersConnection', nodes: Array<{ __typename?: 'Consumer', id: any, vendors?: any | null, createdAt: any, engagebay?: any | null, account?: { __typename?: 'Account', firstName: string, lastName: string, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', value: any }> } } | null, inquiries: { __typename?: 'InquiriesConnection', nodes: Array<{ __typename?: 'Inquiry', details: any }> } }> } | null };

export type InquiryByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InquiryByIdQuery = { __typename?: 'Query', inquiryById?: { __typename?: 'Inquiry', nodeId: string, id: any, details: any, detailsConfirmed?: any | null, providers?: any | null, flags?: any | null, potentialProviders: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: { __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved: boolean, signed?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> }, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any }> } } | null };

export type UpdateInquiryMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type UpdateInquiryMutation = { __typename?: 'Mutation', updateInquiry?: { __typename?: 'UpdateInquiryPayload', inquiry?: { __typename?: 'Inquiry', nodeId: string, id: any, providers?: any | null, details: any, flags?: any | null } | null } | null };

export type AddInquiryAddressMutationVariables = Exact<{
  input: AddInquiryAddressInput;
}>;


export type AddInquiryAddressMutation = { __typename?: 'Mutation', addInquiryAddress?: { __typename?: 'AddInquiryAddressPayload', inquiry?: { __typename?: 'Inquiry', nodeId: string, inquiryAddresses: { __typename?: 'InquiryAddressesConnection', nodes: Array<{ __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any }> } } | null } | null };

export type UpdateInquiryAddressMutationVariables = Exact<{
  input: UpdateInquiryAddressInput;
}>;


export type UpdateInquiryAddressMutation = { __typename?: 'Mutation', updateInquiryAddress?: { __typename?: 'UpdateInquiryAddressPayload', inquiryAddress?: { __typename?: 'InquiryAddress', nodeId: string, id: any, address: string, price?: any | null, latitude: any, longitude: any, ebDealUniqueId?: string | null, inquiry?: { __typename?: 'Inquiry', nodeId: string, potentialProviders: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: { __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved: boolean, signed?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } | null }> } } | null } | null } | null };

export type LeadQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type LeadQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any, createdAt: any, inquiry?: { __typename?: 'Inquiry', consumer?: { __typename?: 'Consumer', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, avatar?: { __typename?: 'Media', url?: string | null } | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', type: string, value: any }> } } | null } | null } | null } | null };

export type LeadByIdQueryVariables = Exact<{
  input: Scalars['UUID'];
}>;


export type LeadByIdQuery = { __typename?: 'Query', leadById?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any, createdAt: any, inquiry?: { __typename?: 'Inquiry', consumer?: { __typename?: 'Consumer', account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, avatar?: { __typename?: 'Media', url?: string | null } | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', type: string, value: any }> } } | null } | null } | null } | null };

export type UpdateLeadMutationVariables = Exact<{
  input: UpdateLeadInput;
}>;


export type UpdateLeadMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: { __typename?: 'Lead', id: any, nodeId: string, status: LeadStatus, info: any, history: any, transaction: any } | null } | null };

export type LinkQueryVariables = Exact<{
  input: Scalars['UUID'];
}>;


export type LinkQuery = { __typename?: 'Query', linkById?: { __typename?: 'Link', path: string, data?: any | null } | null };

export type CityDistanceQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type CityDistanceQuery = { __typename?: 'Query', cityDistance?: number | null };

export type CitiesDistanceQueryVariables = Exact<{
  city1: Scalars['String'];
  state1: Scalars['String'];
  city2: Scalars['String'];
  state2: Scalars['String'];
}>;


export type CitiesDistanceQuery = { __typename?: 'Query', citiesDistance?: number | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', jwtToken?: any | null } | null };

export type LoginAsMutationVariables = Exact<{
  input: LoginAsInput;
}>;


export type LoginAsMutation = { __typename?: 'Mutation', loginAs?: { __typename?: 'LoginAsPayload', link?: { __typename?: 'Link', id: any } | null } | null };

export type NearestZipQueryVariables = Exact<{
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type NearestZipQuery = { __typename?: 'Query', nearestZip?: any | null };

export type PotentialProviderFragmentFragment = { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, phone?: string | null, email: any, info: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, syntheticStatus?: string | null, approvalRequested?: any | null, public: boolean, approved: boolean, signed?: boolean | null, docusignStatus?: string | null, docusignSigned?: any | null, bizDev?: boolean | null, image?: { __typename?: 'Media', url?: string | null } | null, transactions: { __typename?: 'ProviderTransactionsConnection', nodes: Array<{ __typename?: 'ProviderTransaction', nodeId: string, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, closeDate: any, closePrice: number, location?: any | null, lookupFailed?: any | null }> }, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null } & { ' $fragmentName'?: 'PotentialProviderFragmentFragment' };

export type DealPotentialProvidersQueryVariables = Exact<{
  dealUniqueId: Scalars['String'];
}>;


export type DealPotentialProvidersQuery = { __typename?: 'Query', dealPotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type CityStatePotentialProvidersQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
}>;


export type CityStatePotentialProvidersQuery = { __typename?: 'Query', cityStatePotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type ZipPotentialProvidersQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type ZipPotentialProvidersQuery = { __typename?: 'Query', zipPotentialProviders?: { __typename?: 'PotentialProvidersConnection', nodes: Array<{ __typename?: 'PotentialProvider', distance?: number | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'PotentialProviderFragmentFragment': PotentialProviderFragmentFragment } }
      ) | null }> } | null };

export type ProviderDataFragment = { __typename?: 'Provider', nodeId: string, id: any, accountId: any, signed?: boolean | null, engagebay?: any | null, type: ProviderType, name: string, slug?: any | null, title: string, gender?: string | null, phone?: string | null, email: any, info: any, transactionHistory: any, setupComplete?: any | null, approvalRequested?: any | null, approved: boolean, public: boolean, minPrice?: number | null, maxPrice?: number | null, createdAt: any, areaCenter?: any | null, status?: any | null, docusignStatus?: string | null, docusignSigned?: any | null, docusignExpiration?: any | null, profileComplete?: number | null, bizDev?: boolean | null, deletedAt?: any | null, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, suppressMessages?: boolean | null, campaign?: any | null, deletedAt?: any | null, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any }> } } | null, image?: { __typename?: 'Media', url?: string | null } | null } & { ' $fragmentName'?: 'ProviderDataFragment' };

export type ProviderQueryVariables = Exact<{
  nodeId: Scalars['ID'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type ProviderByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProviderByIdQuery = { __typename?: 'Query', providerById?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type ProviderBySlugQueryVariables = Exact<{
  slug: Scalars['Slug'];
}>;


export type ProviderBySlugQuery = { __typename?: 'Query', providerBySlug?: (
    { __typename?: 'Provider' }
    & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
  ) | null };

export type UpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'UpdateProviderPayload', provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, title: string, slug?: any | null, phone?: string | null, email: any, info: any, transactionHistory: any, setupComplete?: any | null, approvalRequested?: any | null, approved: boolean, public: boolean, minPrice?: number | null, maxPrice?: number | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null } | null } | null };

export type ProvidersByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type ProvidersByLocationQuery = { __typename?: 'Query', providersByLocation?: { __typename?: 'ProvidersConnection', nodes: Array<(
      { __typename?: 'Provider', cities?: any | null, engagebay?: any | null, info: any, account?: { __typename?: 'Account', id: any, contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', nodeId: string, type: string, value: any, verifiedAt?: any | null }> } } | null }
      & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
    )> } | null };

export type ProvidersByCityStateQueryVariables = Exact<{
  city: Scalars['String'];
  state: Scalars['String'];
  miles?: InputMaybe<Scalars['BigFloat']>;
}>;


export type ProvidersByCityStateQuery = { __typename?: 'Query', providersByCityState?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved: boolean, signed?: boolean | null, bizDev?: boolean | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null }> } | null };

export type ProvidersNearestQueryVariables = Exact<{
  latitude: Scalars['BigFloat'];
  longitude: Scalars['BigFloat'];
}>;


export type ProvidersNearestQuery = { __typename?: 'Query', providersNearest?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', id: any, name: string, title: string, phone?: string | null, email: any, info: any, transactionHistory: any, profileComplete?: number | null, geoJson?: any | null, engagebay?: any | null, status?: any | null, approvalRequested?: any | null, public: boolean, approved: boolean, signed?: boolean | null, bizDev?: boolean | null, docusignStatus?: string | null, image?: { __typename?: 'Media', url?: string | null } | null, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string } | null }> } | null };

export type ProviderTransactionLocationsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProviderTransactionLocationsQuery = { __typename?: 'Query', providerById?: { __typename?: 'Provider', transactionLocations?: any | null } | null };

export type ProvidersByTransactionLocationQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}>;


export type ProvidersByTransactionLocationQuery = { __typename?: 'Query', providersByTransactionLocation?: { __typename?: 'ProviderTransactionCountsConnection', nodes: Array<{ __typename?: 'ProviderTransactionCount', count?: any | null, provider?: { __typename?: 'Provider', nodeId: string, id: any, name: string, location?: any | null, status?: any | null, syntheticStatus?: string | null, docusignStatus?: string | null, docusignSigned?: any | null, signed?: boolean | null, public: boolean, approved: boolean, engagebay?: any | null, info: any, bizDev?: boolean | null, transactions: { __typename?: 'ProviderTransactionsConnection', nodes: Array<{ __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null }> }, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string, campaign?: any | null } | null } | null }> } | null };

export type ProvidersQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ProvidersQuery = { __typename?: 'Query', allProviders?: { __typename?: 'ProvidersConnection', nodes: Array<(
      { __typename?: 'Provider' }
      & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
    )> } | null };

export type ProvidersListQueryVariables = Exact<{
  options?: InputMaybe<Scalars['JSON']>;
}>;


export type ProvidersListQuery = { __typename?: 'Query', allProviders?: { __typename?: 'ProvidersConnection', nodes: Array<{ __typename?: 'Provider', nodeId: string, id: any, name: string, engagebayId?: string | null, email: any, brokerageName?: string | null, status?: any | null, syntheticStatus?: string | null, signed?: boolean | null, docusignStatus?: string | null, docusignSigned?: any | null, profileComplete?: number | null, location?: any | null, createdAt: any, public: boolean, approved: boolean, account?: { __typename?: 'Account', id: any, firstName: string, lastName: string, campaign?: any | null } | null }> } | null };

export type RedeemPointsMutationVariables = Exact<{
  input: PointsLedgerRedeemInput;
}>;


export type RedeemPointsMutation = { __typename?: 'Mutation', pointsLedgerRedeem?: { __typename?: 'PointsLedgerRedeemPayload', account?: { __typename?: 'Account', nodeId: string, id: any, pointsAvailable?: number | null, pointsLedger: { __typename?: 'PointsLedgersConnection', nodes: Array<{ __typename?: 'PointsLedger', nodeId: string, id: any, entryType: PointsLedgerEntryType, quantity: number, note?: string | null, createdAt: any, accountByCreatedBy?: { __typename?: 'Account', firstName: string, lastName: string, nodeId: string, id: any } | null }> } } | null } | null };

export type RemoveAccountMutationVariables = Exact<{
  input: RemoveAccountInput;
}>;


export type RemoveAccountMutation = { __typename?: 'Mutation', removeAccount?: { __typename?: 'RemoveAccountPayload', clientMutationId?: string | null, account?: { __typename?: 'Account', id: any, consumer?: (
        { __typename?: 'Consumer' }
        & { ' $fragmentRefs'?: { 'ConsumerDataFragment': ConsumerDataFragment } }
      ) | null, provider?: (
        { __typename?: 'Provider' }
        & { ' $fragmentRefs'?: { 'ProviderDataFragment': ProviderDataFragment } }
      ) | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', clientMutationId?: string | null } | null };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword?: { __typename?: 'SetPasswordPayload', clientMutationId?: string | null } | null };

export type TokenLoginMutationVariables = Exact<{
  input: TokenLoginInput;
}>;


export type TokenLoginMutation = { __typename?: 'Mutation', tokenLogin?: { __typename?: 'TokenLoginPayload', jwtToken?: any | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountPayload', query?: { __typename?: 'Query', viewer?: (
        { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string, onboardedBy?: any | null, suppressMessages?: boolean | null }
        & { ' $fragmentRefs'?: { 'ViewerAvatarFragment': ViewerAvatarFragment } }
      ) | null } | null } | null };

export type UpdateAccountListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateAccountListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', firstName: string, lastName: string, campaign?: any | null, nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateConsumerListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateConsumerListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', vendors?: any | null, engagebay?: any | null, providersInArea?: string | null, consultation?: any | null, deletedAt?: any | null, nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateContactListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateContactListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', type: string, value: any, nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInquiryListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInquiryListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', details: any, detailsConfirmed?: any | null, matches?: Array<any | null> | null, providers?: any | null, flags?: any | null, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInquiryAddressListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInquiryAddressListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', address: string, latitude: any, longitude: any, price?: any | null, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateInvitationListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateInvitationListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', firstName: string, lastName: string, email: any, phone?: string | null, info?: any | null, nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateLeadListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateLeadListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', status: LeadStatus, info: any, history: any, transaction: any, ebDealUniqueId?: string | null, nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateProviderListenerSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateProviderListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNodeId?: string | null, relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', type: ProviderType, name: string, gender?: string | null, title: string, slug?: any | null, phone?: string | null, email: any, info: any, transactionHistory: any, approved: boolean, public: boolean, tier?: number | null, setupComplete?: any | null, profileComplete?: number | null, approvalRequested?: any | null, minPrice?: number | null, maxPrice?: number | null, status?: any | null, syntheticStatus?: string | null, bizDev?: boolean | null, languages?: Array<string | null> | null, specialties?: Array<string | null> | null, nickname?: string | null, pronouns?: string | null, geoJson?: any | null, areaCenter?: any | null, engagebay?: any | null, engagebayId?: string | null, deletedAt?: any | null, nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', nodeId: string } | null } };

export type UpdateTransactionLocationMutationVariables = Exact<{
  input: UpdateTransactionLocationInput;
}>;


export type UpdateTransactionLocationMutation = { __typename?: 'Mutation', updateTransactionLocation?: { __typename?: 'UpdateTransactionLocationPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, lookupFailed?: any | null, location?: any | null } | null } | null };

export type UpdateTransactionLocationLookupFailedMutationVariables = Exact<{
  input: UpdateTransactionLocationLookupFailedInput;
}>;


export type UpdateTransactionLocationLookupFailedMutation = { __typename?: 'Mutation', updateTransactionLocationLookupFailed?: { __typename?: 'UpdateTransactionLocationLookupFailedPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, lookupFailed?: any | null, location?: any | null } | null } | null };

export type GetNextProviderTransactionQueryVariables = Exact<{
  t: Scalars['String'];
}>;


export type GetNextProviderTransactionQuery = { __typename?: 'Query', getNextProviderTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, location?: any | null, lookupFailed?: any | null } | null };

export type UpdateProviderTransactionByIdMutationVariables = Exact<{
  input: UpdateProviderTransactionByIdInput;
}>;


export type UpdateProviderTransactionByIdMutation = { __typename?: 'Mutation', updateProviderTransactionById?: { __typename?: 'UpdateProviderTransactionPayload', providerTransaction?: { __typename?: 'ProviderTransaction', nodeId: string, id: any, address1: string, address2?: string | null, city: string, state: string, zip?: string | null, location?: any | null, lookupFailed?: any | null } | null } | null };

export type UserActivityListenerSubscriptionVariables = Exact<{
  topic: Scalars['String'];
}>;


export type UserActivityListenerSubscription = { __typename?: 'Subscription', listen: { __typename?: 'ListenPayload', relatedNode?: { __typename?: 'Account', nodeId: string } | { __typename?: 'Consumer', nodeId: string } | { __typename?: 'Contact', nodeId: string } | { __typename?: 'DocusignEnvelope', nodeId: string } | { __typename?: 'DocusignEnvelopeRecipient', nodeId: string } | { __typename?: 'ExternalLead', nodeId: string } | { __typename?: 'Inquiry', nodeId: string } | { __typename?: 'InquiryAddress', nodeId: string } | { __typename?: 'Invitation', nodeId: string } | { __typename?: 'Lead', nodeId: string } | { __typename?: 'License', nodeId: string } | { __typename?: 'Link', nodeId: string } | { __typename?: 'Log', nodeId: string } | { __typename?: 'Media', nodeId: string } | { __typename?: 'Message', nodeId: string } | { __typename?: 'Payment', nodeId: string } | { __typename?: 'PointsLedger', nodeId: string } | { __typename?: 'Provider', nodeId: string } | { __typename?: 'ProviderTransaction', nodeId: string } | { __typename?: 'Query', nodeId: string } | { __typename?: 'Redirect', nodeId: string } | { __typename?: 'UserActivity', instanceId: string, path: string, data?: any | null, createdAt: any, nodeId: string, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null } | null } };

export type CreateUserActivityMutationVariables = Exact<{
  input: CreateUserActivityInput;
}>;


export type CreateUserActivityMutation = { __typename?: 'Mutation', createUserActivity?: { __typename?: 'CreateUserActivityPayload', userActivity?: { __typename?: 'UserActivity', nodeId: string, instanceId: string, path: string, data?: any | null, createdAt: any, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null } | null } | null };

export type UserActivitiesQueryQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type UserActivitiesQueryQuery = { __typename?: 'Query', userActivities?: { __typename?: 'UserActivitiesConnection', nodes: Array<{ __typename?: 'UserActivity', nodeId: string, instanceId: string, path: string, data?: any | null, createdAt: any, account?: { __typename?: 'Account', nodeId: string, id: any, firstName: string, lastName: string } | null }> } | null };

export type ViewerAvatarFragment = { __typename?: 'Account', avatar?: { __typename?: 'Media', nodeId: string, url?: string | null, meta?: any | null } | null } & { ' $fragmentName'?: 'ViewerAvatarFragment' };

export type ViewerContactsFragment = { __typename?: 'Account', contacts: { __typename?: 'ContactsConnection', nodes: Array<{ __typename?: 'Contact', id: any, nodeId: string, type: string, value: any, verifiedAt?: any | null, verificationAttempts?: number | null }> } } & { ' $fragmentName'?: 'ViewerContactsFragment' };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: (
    { __typename?: 'Account', nodeId: string, id: any, admin?: boolean | null, firstName: string, lastName: string }
    & { ' $fragmentRefs'?: { 'ViewerAvatarFragment': ViewerAvatarFragment;'ViewerContactsFragment': ViewerContactsFragment } }
  ) | null };

export type ZipGeoJsonQueryVariables = Exact<{
  zip?: InputMaybe<Scalars['String']>;
}>;


export type ZipGeoJsonQuery = { __typename?: 'Query', zipGeoJson?: any | null };

export const ConsumerDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsumerData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Consumer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"undeliverableAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pointsLedger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountByCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersInArea"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<ConsumerDataFragment, unknown>;
export const PotentialProviderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PotentialProviderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"closePrice"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<PotentialProviderFragmentFragment, unknown>;
export const ProviderDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"areaCenter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"docusignExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<ProviderDataFragment, unknown>;
export const ViewerAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewerAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]} as unknown as DocumentNode<ViewerAvatarFragment, unknown>;
export const ViewerContactsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViewerContacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"verificationAttempts"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerContactsFragment, unknown>;
export const AccountByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountByIdQuery, AccountByIdQueryVariables>;
export const AdminUpdateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUpdateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminUpdateAccountMutation, AdminUpdateAccountMutationVariables>;
export const AgentsByCityStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentsByCityState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentsByCityState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<AgentsByCityStateQuery, AgentsByCityStateQueryVariables>;
export const AutocompleteLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zipCode"}}}]}]}}]} as unknown as DocumentNode<AutocompleteLocationQuery, AutocompleteLocationQueryVariables>;
export const CityGeoJsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityGeoJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityGeoJson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}]}}]} as unknown as DocumentNode<CityGeoJsonQuery, CityGeoJsonQueryVariables>;
export const ConsumerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"undeliverableAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pointsLedger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountByCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"providersInArea"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<ConsumerByIdQuery, ConsumerByIdQueryVariables>;
export const UpdateConsumerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConsumer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConsumerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConsumer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConsumerMutation, UpdateConsumerMutationVariables>;
export const ConsumersListDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allConsumers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsumerData"}}]}}]}}]}},...ConsumerDataFragmentDoc.definitions]} as unknown as DocumentNode<ConsumersListQuery, ConsumersListQueryVariables>;
export const ConsumersByLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConsumersByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumersByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"email","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConsumersByLocationQuery, ConsumersByLocationQueryVariables>;
export const InquiryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InquiryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"potentialProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InquiryByIdQuery, InquiryByIdQueryVariables>;
export const UpdateInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryMutation, UpdateInquiryMutationVariables>;
export const AddInquiryAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddInquiryAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddInquiryAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addInquiryAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddInquiryAddressMutation, AddInquiryAddressMutationVariables>;
export const UpdateInquiryAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInquiryAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInquiryAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInquiryAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inquiryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"potentialProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryAddressMutation, UpdateInquiryAddressMutationVariables>;
export const LeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Lead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadQuery, LeadQueryVariables>;
export const LeadByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadByIdQuery, LeadByIdQueryVariables>;
export const UpdateLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLeadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadMutation, UpdateLeadMutationVariables>;
export const LinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Link"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<LinkQuery, LinkQueryVariables>;
export const CityDistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityDistance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}]}]}}]} as unknown as DocumentNode<CityDistanceQuery, CityDistanceQueryVariables>;
export const CitiesDistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CitiesDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"citiesDistance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city1"}}},{"kind":"Argument","name":{"kind":"Name","value":"state1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state1"}}},{"kind":"Argument","name":{"kind":"Name","value":"city2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city2"}}},{"kind":"Argument","name":{"kind":"Name","value":"state2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state2"}}}]}]}}]} as unknown as DocumentNode<CitiesDistanceQuery, CitiesDistanceQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwtToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LoginAsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginAs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginAsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginAs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginAsMutation, LoginAsMutationVariables>;
export const NearestZipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NearestZip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearestZip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}]}]}}]} as unknown as DocumentNode<NearestZipQuery, NearestZipQueryVariables>;
export const DealPotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DealPotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dealUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dealPotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dealUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dealUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<DealPotentialProvidersQuery, DealPotentialProvidersQueryVariables>;
export const CityStatePotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CityStatePotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityStatePotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CityStatePotentialProvidersQuery, CityStatePotentialProvidersQueryVariables>;
export const ZipPotentialProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZipPotentialProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipPotentialProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PotentialProviderFragment"}}]}}]}}]}}]}},...PotentialProviderFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ZipPotentialProvidersQuery, ZipPotentialProvidersQueryVariables>;
export const ProviderDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Provider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderQuery, ProviderQueryVariables>;
export const ProviderByIdDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderByIdQuery, ProviderByIdQueryVariables>;
export const ProviderBySlugDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Slug"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProviderBySlugQuery, ProviderBySlugQueryVariables>;
export const UpdateProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const ProvidersByLocationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}},{"kind":"Field","name":{"kind":"Name","value":"cities"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]}}]}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProvidersByLocationQuery, ProvidersByLocationQueryVariables>;
export const ProvidersByCityStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByCityState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByCityState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"miles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersByCityStateQuery, ProvidersByCityStateQueryVariables>;
export const ProvidersNearestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersNearest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersNearest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"Argument","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersNearestQuery, ProvidersNearestQueryVariables>;
export const ProviderTransactionLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderTransactionLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionLocations"}}]}}]}}]} as unknown as DocumentNode<ProviderTransactionLocationsQuery, ProviderTransactionLocationsQueryVariables>;
export const ProvidersByTransactionLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersByTransactionLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providersByTransactionLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersByTransactionLocationQuery, ProvidersByTransactionLocationQueryVariables>;
export const ProvidersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Providers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}}]}},...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<ProvidersQuery, ProvidersQueryVariables>;
export const ProvidersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProvidersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"engagebayId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"brokerageName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"docusignStatus"}},{"kind":"Field","name":{"kind":"Name","value":"docusignSigned"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}}]}}]}}]}}]} as unknown as DocumentNode<ProvidersListQuery, ProvidersListQueryVariables>;
export const RedeemPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedeemPoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PointsLedgerRedeemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointsLedgerRedeem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pointsAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"pointsLedger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountByCreatedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RedeemPointsMutation, RedeemPointsMutationVariables>;
export const RemoveAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"consumer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsumerData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderData"}}]}}]}}]}}]}},...ConsumerDataFragmentDoc.definitions,...ProviderDataFragmentDoc.definitions]} as unknown as DocumentNode<RemoveAccountMutation, RemoveAccountMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<SetPasswordMutation, SetPasswordMutationVariables>;
export const TokenLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TokenLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwtToken"}}]}}]}}]} as unknown as DocumentNode<TokenLoginMutation, TokenLoginMutationVariables>;
export const UpdateAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"onboardedBy"}},{"kind":"Field","name":{"kind":"Name","value":"suppressMessages"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerAvatar"}}]}}]}}]}}]}},...ViewerAvatarFragmentDoc.definitions]} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAccountListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateAccountListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Account","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountListenerSubscription, UpdateAccountListenerSubscriptionVariables>;
export const UpdateConsumerListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateConsumerListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Consumer","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Consumer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendors"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"providersInArea"}},{"kind":"Field","name":{"kind":"Name","value":"consultation"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConsumerListenerSubscription, UpdateConsumerListenerSubscriptionVariables>;
export const UpdateContactListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateContactListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Contact","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContactListenerSubscription, UpdateContactListenerSubscriptionVariables>;
export const UpdateInquiryListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInquiryListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Inquiry","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Inquiry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"detailsConfirmed"}},{"kind":"Field","name":{"kind":"Name","value":"matches"}},{"kind":"Field","name":{"kind":"Name","value":"providers"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryListenerSubscription, UpdateInquiryListenerSubscriptionVariables>;
export const UpdateInquiryAddressListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInquiryAddressListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:InquiryAddress","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InquiryAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInquiryAddressListenerSubscription, UpdateInquiryAddressListenerSubscriptionVariables>;
export const UpdateInvitationListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateInvitationListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Invitation","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invitation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInvitationListenerSubscription, UpdateInvitationListenerSubscriptionVariables>;
export const UpdateLeadListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateLeadListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Lead","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Lead"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"history"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"}},{"kind":"Field","name":{"kind":"Name","value":"ebDealUniqueId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadListenerSubscription, UpdateLeadListenerSubscriptionVariables>;
export const UpdateProviderListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UpdateProviderListener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"StringValue","value":"update:Provider","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"transactionHistory"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"setupComplete"}},{"kind":"Field","name":{"kind":"Name","value":"profileComplete"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequested"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"syntheticStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bizDev"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"geoJson"}},{"kind":"Field","name":{"kind":"Name","value":"areaCenter"}},{"kind":"Field","name":{"kind":"Name","value":"engagebay"}},{"kind":"Field","name":{"kind":"Name","value":"engagebayId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderListenerSubscription, UpdateProviderListenerSubscriptionVariables>;
export const UpdateTransactionLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTransactionLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTransactionLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTransactionLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionLocationMutation, UpdateTransactionLocationMutationVariables>;
export const UpdateTransactionLocationLookupFailedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTransactionLocationLookupFailed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTransactionLocationLookupFailedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTransactionLocationLookupFailed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionLocationLookupFailedMutation, UpdateTransactionLocationLookupFailedMutationVariables>;
export const GetNextProviderTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNextProviderTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"t"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNextProviderTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"t"},"value":{"kind":"Variable","name":{"kind":"Name","value":"t"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}}]} as unknown as DocumentNode<GetNextProviderTransactionQuery, GetNextProviderTransactionQueryVariables>;
export const UpdateProviderTransactionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProviderTransactionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderTransactionByIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProviderTransactionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"lookupFailed"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProviderTransactionByIdMutation, UpdateProviderTransactionByIdMutationVariables>;
export const UserActivityListenerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserActivityListener"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"topic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserActivityListenerSubscription, UserActivityListenerSubscriptionVariables>;
export const CreateUserActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserActivityMutation, CreateUserActivityMutationVariables>;
export const UserActivitiesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserActivitiesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserActivitiesQueryQuery, UserActivitiesQueryQueryVariables>;
export const ViewerDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViewerContacts"}}]}}]}},...ViewerAvatarFragmentDoc.definitions,...ViewerContactsFragmentDoc.definitions]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const ZipGeoJsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZipGeoJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipGeoJson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zipCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}]}]}}]} as unknown as DocumentNode<ZipGeoJsonQuery, ZipGeoJsonQueryVariables>;